import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

import DefaultLayout from "/home/runner/work/workplace-xg/workplace-xg/node_modules/gatsby-theme-carbon/src/templates/Default.js";
import SlatGradientLoop from "../../videos/slat_gradient_loop.mp4";
import ibmWatson from "./videos/ibm-watson-logo.mp4";
import ImageCollection from "../../components/ImageCollection";
export const _frontmatter = {};

const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};

const PageDescription = makeShortcode("PageDescription");
const AnchorLinks = makeShortcode("AnchorLinks");
const AnchorLink = makeShortcode("AnchorLink");
const Column = makeShortcode("Column");
const Caption = makeShortcode("Caption");
const GifPlayer = makeShortcode("GifPlayer");
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">




    <PageDescription mdxType="PageDescription">
      <p>{`IBM has a rich legacy of design across many disciplines from industrial design to architecture. Design characteristics are the elements of a space that make our environments instantly recognizable as IBM. These characteristics derive from our design language and serve to reinforce our brand within the built environment. We invite our design partners to explore how our design character can be reflected regionally and around the world. Learn more about our `}<a parentName="p" {...{
          "href": "https://www.ibm.com/design/language/philosophy/pov"
        }}>{`design philosophy`}</a>{`.`}</p>
    </PageDescription>
    <AnchorLinks mdxType="AnchorLinks">
  <AnchorLink mdxType="AnchorLink">Rhythm and pattern</AnchorLink>
  <AnchorLink mdxType="AnchorLink">Perspectives</AnchorLink>
  <AnchorLink mdxType="AnchorLink">Geometry</AnchorLink>
  <AnchorLink mdxType="AnchorLink">Duality</AnchorLink>
    </AnchorLinks>
    <h2>{`Rhythm and pattern`}</h2>
    <p>{`IBM creates intelligent solutions. Our products are predicated on finding patterns in data, in human behavior and in the world around us. These patterns enable us to build tools that provide insight for our clients and our business. Pattern defines our very identity. Our approach to pattern design is based on the IBM 2x Grid, which serves as the underlying framework for all design at IBM. Learn more about the `}<a parentName="p" {...{
        "href": "https://www.ibm.com/design/language/2x-grid"
      }}>{`2x Grid`}</a>{`.`}</p>
    <p>{`The use of pattern within our environments and architecture reinforces our brand character. The linear geometry inherent in the IBM logo can be applied in different dimensions of interior design or brand expression. Learn more about `}<a parentName="p" {...{
        "href": "/workplace-xg/interior-architecture/pattern/overview"
      }}>{`pattern design and application`}</a>{`.`}</p>
    <ImageCollection mdxType="ImageCollection">
      <Column colLg={4} colMd={4} colSm={4} mdxType="Column">
        <span {...{
          "className": "gatsby-resp-image-wrapper",
          "style": {
            "position": "relative",
            "display": "block",
            "marginLeft": "auto",
            "marginRight": "auto",
            "maxWidth": "576px"
          }
        }}>{`
      `}<span parentName="span" {...{
            "className": "gatsby-resp-image-background-image",
            "style": {
              "paddingBottom": "100%",
              "position": "relative",
              "bottom": "0",
              "left": "0",
              "backgroundImage": "url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAUCAIAAAAC64paAAAACXBIWXMAAAsSAAALEgHS3X78AAABKElEQVQ4y+1TvYqDQBj07ewFH8HKxsZCEOQghT8PkGBpJKBCrMTKSrQIQQmIEkgUYq+CiAjRu48s58FhipDyboplvm93dmbZXezzDWB/XTyO4/1+RyMi0zQBmR5AnZedkfipM5ory/J0OuV5nmVZHMdQtm0LpK7rYRiSJLndbvPiHzFEgtGyLIIgNE1jGIamaY7jdrsdSZKqqoZhiOO4aZrodAvO4AN6IIfDwTCM7XYL5o7jrNdrXdc3m03f9wvOqIZ4iqIAd13344Hr9QpBRFGUJEmW5aqqFsQoCZhQFGXbNsgEQVitVuDPsqznecfjkef5/X7/NPblcoGzpWkaRZHv+0VRNE0TBEHXdTALzfP5vOD81lXNi9DDGL8xd1DaX1tg/1/yNXwBSrBtv2vpDZIAAAAASUVORK5CYII=')",
              "backgroundSize": "cover",
              "display": "block"
            }
          }}></span>{`
  `}<img parentName="span" {...{
            "className": "gatsby-resp-image-image",
            "alt": "IBM 8-bar logo",
            "title": "IBM 8-bar logo",
            "src": "/workplace-xg/static/02adcd0a53f1e9834166d439764d628f/a5df1/ibm-logo.png",
            "srcSet": ["/workplace-xg/static/02adcd0a53f1e9834166d439764d628f/7fc1e/ibm-logo.png 288w", "/workplace-xg/static/02adcd0a53f1e9834166d439764d628f/a5df1/ibm-logo.png 576w"],
            "sizes": "(max-width: 576px) 100vw, 576px",
            "style": {
              "width": "100%",
              "height": "100%",
              "margin": "0",
              "verticalAlign": "middle",
              "position": "absolute",
              "top": "0",
              "left": "0"
            },
            "loading": "lazy"
          }}></img>{`
    `}</span>
        <Caption mdxType="Caption">IBM 8-bar logo</Caption>
      </Column>
      <Column colLg={4} colMd={4} colSm={4} mdxType="Column">
        <span {...{
          "className": "gatsby-resp-image-wrapper",
          "style": {
            "position": "relative",
            "display": "block",
            "marginLeft": "auto",
            "marginRight": "auto",
            "maxWidth": "576px"
          }
        }}>{`
      `}<span parentName="span" {...{
            "className": "gatsby-resp-image-background-image",
            "style": {
              "paddingBottom": "100%",
              "position": "relative",
              "bottom": "0",
              "left": "0",
              "backgroundImage": "url('data:image/jpeg;base64,/9j/2wBDABALDA4MChAODQ4SERATGCgaGBYWGDEjJR0oOjM9PDkzODdASFxOQERXRTc4UG1RV19iZ2hnPk1xeXBkeFxlZ2P/2wBDARESEhgVGC8aGi9jQjhCY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2P/wgARCAAUABQDASIAAhEBAxEB/8QAGAABAQEBAQAAAAAAAAAAAAAAAAQBAwL/xAAXAQEAAwAAAAAAAAAAAAAAAAACAAED/9oADAMBAAIQAxAAAAGzPXGpjkKpiGZRm//EAB0QAAEDBQEAAAAAAAAAAAAAAAEAAjQQERITIST/2gAIAQEAAQUCfHNHRsrhE+d3RsK//8QAFhEAAwAAAAAAAAAAAAAAAAAAABAR/9oACAEDAQE/ASP/xAAWEQADAAAAAAAAAAAAAAAAAAAAEBH/2gAIAQIBAT8BK//EABoQAAICAwAAAAAAAAAAAAAAAAEQAhFRYnH/2gAIAQEABj8CjxisMDV//8QAGxABAQACAwEAAAAAAAAAAAAAAQAhMRFBUWH/2gAIAQEAAT8hhBnE4hyuhT4ns51KznumL6aTcdvDf//aAAwDAQACAAMAAAAQDM89/8QAFxEAAwEAAAAAAAAAAAAAAAAAAAExEP/aAAgBAwEBPxBTCFD/xAAXEQADAQAAAAAAAAAAAAAAAAAAATEQ/9oACAECAQE/EHcMdP/EABwQAQEAAgMBAQAAAAAAAAAAAAERACFBcYGRMf/aAAgBAQABPxACgd/TFFBa8Yq0y94skpUXcvGUGFnSXD3UT3AZIo/TCLSX/ENvONHYGVpfmf/Z')",
              "backgroundSize": "cover",
              "display": "block"
            }
          }}></span>{`
  `}<img parentName="span" {...{
            "className": "gatsby-resp-image-image",
            "alt": "Wood system",
            "title": "Wood system",
            "src": "/workplace-xg/static/286ba2bcb054834f6cd7d8096e87bba7/473e3/wood-system.jpg",
            "srcSet": ["/workplace-xg/static/286ba2bcb054834f6cd7d8096e87bba7/69549/wood-system.jpg 288w", "/workplace-xg/static/286ba2bcb054834f6cd7d8096e87bba7/473e3/wood-system.jpg 576w"],
            "sizes": "(max-width: 576px) 100vw, 576px",
            "style": {
              "width": "100%",
              "height": "100%",
              "margin": "0",
              "verticalAlign": "middle",
              "position": "absolute",
              "top": "0",
              "left": "0"
            },
            "loading": "lazy"
          }}></img>{`
    `}</span>
        <Caption mdxType="Caption">Linear wood slat systems</Caption>
      </Column>
      <Column colLg={4} colMd={4} colSm={4} mdxType="Column">
        <span {...{
          "className": "gatsby-resp-image-wrapper",
          "style": {
            "position": "relative",
            "display": "block",
            "marginLeft": "auto",
            "marginRight": "auto",
            "maxWidth": "1152px"
          }
        }}>{`
      `}<span parentName="span" {...{
            "className": "gatsby-resp-image-background-image",
            "style": {
              "paddingBottom": "100%",
              "position": "relative",
              "bottom": "0",
              "left": "0",
              "backgroundImage": "url('data:image/jpeg;base64,/9j/2wBDABALDA4MChAODQ4SERATGCgaGBYWGDEjJR0oOjM9PDkzODdASFxOQERXRTc4UG1RV19iZ2hnPk1xeXBkeFxlZ2P/2wBDARESEhgVGC8aGi9jQjhCY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2P/wgARCAAUABQDASIAAhEBAxEB/8QAGAABAQEBAQAAAAAAAAAAAAAAAAIEAwX/xAAWAQEBAQAAAAAAAAAAAAAAAAABAgD/2gAMAwEAAhADEAAAAc1jMOh3kWS6BR//xAAZEAADAQEBAAAAAAAAAAAAAAAAAQIREhT/2gAIAQEAAQUC862mpWnUIeMmTRNnTP/EABQRAQAAAAAAAAAAAAAAAAAAACD/2gAIAQMBAT8BH//EABQRAQAAAAAAAAAAAAAAAAAAACD/2gAIAQIBAT8BH//EABsQAAICAwEAAAAAAAAAAAAAAAABETICICEx/9oACAEBAAY/ArKCMEdg9ZYstP/EABwQAAICAgMAAAAAAAAAAAAAAAABIVERMWFxkf/aAAgBAQABPyGE+SQgdmTltrFoIEnXpCWna7G2S0LAf//aAAwDAQACAAMAAAAQ/wAXwf/EABYRAAMAAAAAAAAAAAAAAAAAAAAQEf/aAAgBAwEBPxAr/8QAFhEAAwAAAAAAAAAAAAAAAAAAABAR/9oACAECAQE/ECP/xAAeEAEAAwACAgMAAAAAAAAAAAABABEhMUFRYXGhsf/aAAgBAQABPxAcjDWJYVkV27wjHGF5JU6Dt49RIPOUm/UCVHWDcWastLc/M7OCMhhVNv8AZ//Z')",
              "backgroundSize": "cover",
              "display": "block"
            }
          }}></span>{`
  `}<img parentName="span" {...{
            "className": "gatsby-resp-image-image",
            "alt": "Linear lighting systems",
            "title": "Linear lighting systems",
            "src": "/workplace-xg/static/ec1d71d36169d47208da31d77eea118f/2e753/linear-lighting-systems.jpg",
            "srcSet": ["/workplace-xg/static/ec1d71d36169d47208da31d77eea118f/69549/linear-lighting-systems.jpg 288w", "/workplace-xg/static/ec1d71d36169d47208da31d77eea118f/473e3/linear-lighting-systems.jpg 576w", "/workplace-xg/static/ec1d71d36169d47208da31d77eea118f/2e753/linear-lighting-systems.jpg 1152w"],
            "sizes": "(max-width: 1152px) 100vw, 1152px",
            "style": {
              "width": "100%",
              "height": "100%",
              "margin": "0",
              "verticalAlign": "middle",
              "position": "absolute",
              "top": "0",
              "left": "0"
            },
            "loading": "lazy"
          }}></img>{`
    `}</span>
        <Caption mdxType="Caption">Linear lighting systems</Caption>
      </Column>
      <Column colLg={12} colMd={8} colSm={4} mdxType="Column">
        <span {...{
          "className": "gatsby-resp-image-wrapper",
          "style": {
            "position": "relative",
            "display": "block",
            "marginLeft": "auto",
            "marginRight": "auto",
            "maxWidth": "1152px"
          }
        }}>{`
      `}<span parentName="span" {...{
            "className": "gatsby-resp-image-background-image",
            "style": {
              "paddingBottom": "50%",
              "position": "relative",
              "bottom": "0",
              "left": "0",
              "backgroundImage": "url('data:image/jpeg;base64,/9j/2wBDABALDA4MChAODQ4SERATGCgaGBYWGDEjJR0oOjM9PDkzODdASFxOQERXRTc4UG1RV19iZ2hnPk1xeXBkeFxlZ2P/2wBDARESEhgVGC8aGi9jQjhCY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2P/wgARCAAKABQDASIAAhEBAxEB/8QAFwAAAwEAAAAAAAAAAAAAAAAAAAIDBP/EABUBAQEAAAAAAAAAAAAAAAAAAAAC/9oADAMBAAIQAxAAAAG18iQcyh//xAAaEAACAwEBAAAAAAAAAAAAAAABAgARExAS/9oACAEBAAEFAt6YuPGr8Jlmf//EABURAQEAAAAAAAAAAAAAAAAAAAAR/9oACAEDAQE/AYj/xAAWEQEBAQAAAAAAAAAAAAAAAAAAEgH/2gAIAQIBAT8BvVP/xAAcEAABAwUAAAAAAAAAAAAAAAAAARAREjFBUeH/2gAIAQEABj8CiknOlOPc/8QAHRABAAIABwAAAAAAAAAAAAAAAQARECExQVFhkf/aAAgBAQABPyGqJoO0IiJTKHUGBK1Y8z2f/9oADAMBAAIAAwAAABBw7//EABURAQEAAAAAAAAAAAAAAAAAAAAR/9oACAEDAQE/EIQ//8QAFREBAQAAAAAAAAAAAAAAAAAAABH/2gAIAQIBAT8QFv/EABwQAAIDAQADAAAAAAAAAAAAAAABESExQWGBkf/aAAgBAQABPxBxOYnT9F1ukGm2WObGSHk9esmuXkZd/Uf/2Q==')",
              "backgroundSize": "cover",
              "display": "block"
            }
          }}></span>{`
  `}<img parentName="span" {...{
            "className": "gatsby-resp-image-image",
            "alt": "IBM Ehningen Germany",
            "title": "IBM Ehningen Germany",
            "src": "/workplace-xg/static/9711e5827bbf2691d821a7a1d19b1f5e/2e753/ibm-ehningen-germany.jpg",
            "srcSet": ["/workplace-xg/static/9711e5827bbf2691d821a7a1d19b1f5e/69549/ibm-ehningen-germany.jpg 288w", "/workplace-xg/static/9711e5827bbf2691d821a7a1d19b1f5e/473e3/ibm-ehningen-germany.jpg 576w", "/workplace-xg/static/9711e5827bbf2691d821a7a1d19b1f5e/2e753/ibm-ehningen-germany.jpg 1152w", "/workplace-xg/static/9711e5827bbf2691d821a7a1d19b1f5e/74f4b/ibm-ehningen-germany.jpg 1728w", "/workplace-xg/static/9711e5827bbf2691d821a7a1d19b1f5e/f35b7/ibm-ehningen-germany.jpg 1856w"],
            "sizes": "(max-width: 1152px) 100vw, 1152px",
            "style": {
              "width": "100%",
              "height": "100%",
              "margin": "0",
              "verticalAlign": "middle",
              "position": "absolute",
              "top": "0",
              "left": "0"
            },
            "loading": "lazy"
          }}></img>{`
    `}</span>
        <Caption mdxType="Caption">IBM Ehningen, Germany</Caption>
      </Column>
      <Column colLg={6} colMd={4} colSm={4} mdxType="Column">
        <span {...{
          "className": "gatsby-resp-image-wrapper",
          "style": {
            "position": "relative",
            "display": "block",
            "marginLeft": "auto",
            "marginRight": "auto",
            "maxWidth": "896px"
          }
        }}>{`
      `}<span parentName="span" {...{
            "className": "gatsby-resp-image-background-image",
            "style": {
              "paddingBottom": "56.25%",
              "position": "relative",
              "bottom": "0",
              "left": "0",
              "backgroundImage": "url('data:image/jpeg;base64,/9j/2wBDABALDA4MChAODQ4SERATGCgaGBYWGDEjJR0oOjM9PDkzODdASFxOQERXRTc4UG1RV19iZ2hnPk1xeXBkeFxlZ2P/2wBDARESEhgVGC8aGi9jQjhCY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2P/wgARCAALABQDASIAAhEBAxEB/8QAGQAAAgMBAAAAAAAAAAAAAAAAAAIBAwQF/8QAFQEBAQAAAAAAAAAAAAAAAAAAAgH/2gAMAwEAAhADEAAAAdCdWEULw3//xAAYEAADAQEAAAAAAAAAAAAAAAABAgMAE//aAAgBAQABBQKlnFO9NBi8zNCeU8FCj//EABURAQEAAAAAAAAAAAAAAAAAABAR/9oACAEDAQE/AYf/xAAWEQADAAAAAAAAAAAAAAAAAAABEBH/2gAIAQIBAT8BoX//xAAZEAEBAQEBAQAAAAAAAAAAAAABABECMTL/2gAIAQEABj8C6BvbW15L4LAy/8QAHBAAAwABBQAAAAAAAAAAAAAAAAERIUFRYeHx/9oACAEBAAE/IcfVPYTOpeNdG5k3rDySQScH/9oADAMBAAIAAwAAABA7/wD/xAAXEQEBAQEAAAAAAAAAAAAAAAABABFR/9oACAEDAQE/EFdgwv/EABcRAQEBAQAAAAAAAAAAAAAAAAEAEVH/2gAIAQIBAT8QOUut/8QAGxAAAwEAAwEAAAAAAAAAAAAAAAERITFBkdH/2gAIAQEAAT8QnwnSjBJj+Pg4b+rOh4Gq2SsSOAbZGxIqf//Z')",
              "backgroundSize": "cover",
              "display": "block"
            }
          }}></span>{`
  `}<img parentName="span" {...{
            "className": "gatsby-resp-image-image",
            "alt": "IBM Punch Card",
            "title": "IBM Punch Card",
            "src": "/workplace-xg/static/00a6ecc41d84d9512f296b477237134a/968f2/ibm-punch-card.jpg",
            "srcSet": ["/workplace-xg/static/00a6ecc41d84d9512f296b477237134a/69549/ibm-punch-card.jpg 288w", "/workplace-xg/static/00a6ecc41d84d9512f296b477237134a/473e3/ibm-punch-card.jpg 576w", "/workplace-xg/static/00a6ecc41d84d9512f296b477237134a/968f2/ibm-punch-card.jpg 896w"],
            "sizes": "(max-width: 896px) 100vw, 896px",
            "style": {
              "width": "100%",
              "height": "100%",
              "margin": "0",
              "verticalAlign": "middle",
              "position": "absolute",
              "top": "0",
              "left": "0"
            },
            "loading": "lazy"
          }}></img>{`
    `}</span>
        <Caption mdxType="Caption">
  IBM 80-column punch card pattern systems have been used throughout IBM’s
  history. The same principles used to design the punch card in 1964 can also be
  used to inform architecture and design.
        </Caption>
      </Column>
      <Column colLg={6} colMd={4} colSm={4} mdxType="Column">
        <span {...{
          "className": "gatsby-resp-image-wrapper",
          "style": {
            "position": "relative",
            "display": "block",
            "marginLeft": "auto",
            "marginRight": "auto",
            "maxWidth": "896px"
          }
        }}>{`
      `}<span parentName="span" {...{
            "className": "gatsby-resp-image-background-image",
            "style": {
              "paddingBottom": "151.04166666666669%",
              "position": "relative",
              "bottom": "0",
              "left": "0",
              "backgroundImage": "url('data:image/jpeg;base64,/9j/2wBDABALDA4MChAODQ4SERATGCgaGBYWGDEjJR0oOjM9PDkzODdASFxOQERXRTc4UG1RV19iZ2hnPk1xeXBkeFxlZ2P/2wBDARESEhgVGC8aGi9jQjhCY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2P/wgARCAAeABQDASIAAhEBAxEB/8QAGQAAAgMBAAAAAAAAAAAAAAAAAAIDBAUB/8QAFAEBAAAAAAAAAAAAAAAAAAAAAP/aAAwDAQACEAMQAAABW2/TGJg14acYgof/xAAbEAACAgMBAAAAAAAAAAAAAAABAgADBBEjEv/aAAgBAQABBQLFWWjnqY44WjnqVDVV7qq+xHsdGIAPkT//xAAUEQEAAAAAAAAAAAAAAAAAAAAg/9oACAEDAQE/AR//xAAUEQEAAAAAAAAAAAAAAAAAAAAg/9oACAECAQE/AR//xAAcEAACAgMBAQAAAAAAAAAAAAABAgAQESEiQYH/2gAIAQEABj8CLfI1LGpYcno+Vg7nWzX/xAAfEAADAAEDBQAAAAAAAAAAAAAAARFBITFxUWGRofH/2gAIAQEAAT8huncDwfsRSo5VOxKaI5knMCmXDQU+lSqFItiHXqNZOY//2gAMAwEAAgADAAAAEBPKPP/EABQRAQAAAAAAAAAAAAAAAAAAACD/2gAIAQMBAT8QH//EABQRAQAAAAAAAAAAAAAAAAAAACD/2gAIAQIBAT8QH//EAB4QAQACAgIDAQAAAAAAAAAAAAEAESExQWFRkcGx/9oACAEBAAE/EK3Yx+j8myopl3tJqImC5oRYntXMsZdHkSy5WtPdTYJNeNu4k1QBya9QJZjqsq+EFlx68yzHK8gl/YpSYJZo+T//2Q==')",
              "backgroundSize": "cover",
              "display": "block"
            }
          }}></span>{`
  `}<img parentName="span" {...{
            "className": "gatsby-resp-image-image",
            "alt": "IBM Aerospace Headquarters",
            "title": "IBM Aerospace Headquarters",
            "src": "/workplace-xg/static/5fd496732411d473001928fd732bb5d4/968f2/ibm-aerospace-headquarters.jpg",
            "srcSet": ["/workplace-xg/static/5fd496732411d473001928fd732bb5d4/69549/ibm-aerospace-headquarters.jpg 288w", "/workplace-xg/static/5fd496732411d473001928fd732bb5d4/473e3/ibm-aerospace-headquarters.jpg 576w", "/workplace-xg/static/5fd496732411d473001928fd732bb5d4/968f2/ibm-aerospace-headquarters.jpg 896w"],
            "sizes": "(max-width: 896px) 100vw, 896px",
            "style": {
              "width": "100%",
              "height": "100%",
              "margin": "0",
              "verticalAlign": "middle",
              "position": "absolute",
              "top": "0",
              "left": "0"
            },
            "loading": "lazy"
          }}></img>{`
    `}</span>
        <Caption mdxType="Caption">
  IBM Aerospace Headquarters, Los Angeles
  <br /> Designed by Eliot Noyes, 1964
        </Caption>
      </Column>
      <Column colLg={8} colMd={5} colSm={4} mdxType="Column">
        <span {...{
          "className": "gatsby-resp-image-wrapper",
          "style": {
            "position": "relative",
            "display": "block",
            "marginLeft": "auto",
            "marginRight": "auto",
            "maxWidth": "1152px"
          }
        }}>{`
      `}<span parentName="span" {...{
            "className": "gatsby-resp-image-background-image",
            "style": {
              "paddingBottom": "100%",
              "position": "relative",
              "bottom": "0",
              "left": "0",
              "backgroundImage": "url('data:image/jpeg;base64,/9j/2wBDABALDA4MChAODQ4SERATGCgaGBYWGDEjJR0oOjM9PDkzODdASFxOQERXRTc4UG1RV19iZ2hnPk1xeXBkeFxlZ2P/2wBDARESEhgVGC8aGi9jQjhCY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2P/wgARCAAUABQDASIAAhEBAxEB/8QAGQABAAMBAQAAAAAAAAAAAAAAAAIDBAUG/8QAFQEBAQAAAAAAAAAAAAAAAAAAAQL/2gAMAwEAAhADEAAAAa49LDNUoh9FhGcQK//EABoQAAMAAwEAAAAAAAAAAAAAAAABAgMRIRD/2gAIAQEAAQUC6Py+zUaQ8cmWEjSP/8QAFREBAQAAAAAAAAAAAAAAAAAAEAH/2gAIAQMBAT8BIf/EABURAQEAAAAAAAAAAAAAAAAAABAB/9oACAECAQE/ASn/xAAYEAADAQEAAAAAAAAAAAAAAAABEDEAQf/aAAgBAQAGPwLrI1dK/8QAGhABAQEBAQEBAAAAAAAAAAAAAQARIUExYf/aAAgBAQABPyHQvBLYx+uXqOkKouWSD0hI/K//2gAMAwEAAgADAAAAEOPHgP/EABURAQEAAAAAAAAAAAAAAAAAAAEg/9oACAEDAQE/EBh//8QAFREBAQAAAAAAAAAAAAAAAAAAASD/2gAIAQIBAT8QSH//xAAdEAEAAgICAwAAAAAAAAAAAAABABEhMVFhcYGx/9oACAEBAAE/EFM+okzqerILUFeriEQGwiKFMCEo551NC8DK2IOxSvk6E//Z')",
              "backgroundSize": "cover",
              "display": "block"
            }
          }}></span>{`
  `}<img parentName="span" {...{
            "className": "gatsby-resp-image-image",
            "alt": "Pattern",
            "title": "Pattern",
            "src": "/workplace-xg/static/550c650a4fa0cd6c8bce394e8bcfbf3c/2e753/pattern.jpg",
            "srcSet": ["/workplace-xg/static/550c650a4fa0cd6c8bce394e8bcfbf3c/69549/pattern.jpg 288w", "/workplace-xg/static/550c650a4fa0cd6c8bce394e8bcfbf3c/473e3/pattern.jpg 576w", "/workplace-xg/static/550c650a4fa0cd6c8bce394e8bcfbf3c/2e753/pattern.jpg 1152w", "/workplace-xg/static/550c650a4fa0cd6c8bce394e8bcfbf3c/a052a/pattern.jpg 1216w"],
            "sizes": "(max-width: 1152px) 100vw, 1152px",
            "style": {
              "width": "100%",
              "height": "100%",
              "margin": "0",
              "verticalAlign": "middle",
              "position": "absolute",
              "top": "0",
              "left": "0"
            },
            "loading": "lazy"
          }}></img>{`
    `}</span>
      </Column>
      <Column colLg={4} colMd={3} colSm={4} mdxType="Column">
        <span {...{
          "className": "gatsby-resp-image-wrapper",
          "style": {
            "position": "relative",
            "display": "block",
            "marginLeft": "auto",
            "marginRight": "auto",
            "maxWidth": "576px"
          }
        }}>{`
      `}<span parentName="span" {...{
            "className": "gatsby-resp-image-background-image",
            "style": {
              "paddingBottom": "151.04166666666669%",
              "position": "relative",
              "bottom": "0",
              "left": "0",
              "backgroundImage": "url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAeCAIAAACjcKk8AAAACXBIWXMAAAsSAAALEgHS3X78AAAEpUlEQVQ4y12V6XaiShRG6+Vud6JxwiHOoALijIIzcUBRMcbE9JB+3N7IvX/uWlm1sE4N59vnOxWxdl5WjsP4sli664232/Hhue5us2U+/Fu/EF1s12uiq6XjuTuiLBPlfCH5FGOMPUbymZyhNx//+TYamDVZkeKJQjYXjzyVC8V4JFrIPesNNfr9wez1VaUW+fZdvCyX3Vb77PulfL6Ye17MZrqqFvP5fDZrD0eb1brdNPzjqVIsFp/z8+lMqzc4Kyulh/2B2O9cezT6uF61RqOpae5mO7FtQ9c7rRYJHzyPLN6vV0PTmppO5izutTstXV/O52JsWayzR1ZLb5q9HpL6ne71ctm77qDbGw5Mbh5bNuOg1yPNXqdD9LDfc4FYzOZTe7yYzixzCIPT8WgNR4zAY342mY6tMWv+jR6OaDkdDgBjRgDmOZNtKLVMUkIVmafiiX63V6vKEFIqVeSBh7FUKGoNVUokSZv1fIj5dEoCHJlNSelkitsIJGOxZCwOElRA+Lg/PKczmWQKHHVZYRnwUSHWjtPvdk+e11AU1jnzBXvgz990PKbCfBw9D8hEl7M5e2DRaRrkj+bZcDDgflIdj6y9u0PM7eMDYYRJhKpChA2gheKI6PvH+eTDVYRhLoE5o388tlvGq3/erFZmf0AV2DadBNHZZHL0Dt12YAp3ve4YhgjVm/0+bOqK0jZalVI5nKTyLIUc0bosq7Ua5ayWywhRa3XmBbc1VQ1VUiIBJJCw7ekxEo8+kZGzmKPW2+0zqVQYrckyOKMPD5AS1sBsyAqqKEylWIYWYLjBULWO0UKhUq3iylK+UC2VB7i6Vudm1vAnVsvl1Lad+dweDkF98f2Zbf/5+rq+vSESnHCipXAlfnz1fRj9+f379v5umaaY2GNOYiR5OB92e458PfnOYoFyZjBmIE3TrOEQ2iwDKrYPbkYGJLFeUMm6OjLNMG2Uw3k2nrR0w1ksmWyqqtm7i2oaoOVKQZizQZKT0pgMMxuaTidnJYl+Yhv+o/j5TJbofDJlM1ZNJRJBS9Jo+WyODFPBhjSXwyashFyuhkuJSskUpzMf+F/VqCsfguwB49yRcM/18oZCkPCB7Zb3nqMT79EFzUj069cv+p/mE5N7r5I8l5AJjwEmp+zMoApgqOAbwajAdlxOM1NatV4X65cVkM6nk95oEAghA4/uISN3s8Fe4GUzUaqF54K0q9WJZQnOwOIgwXfVUin42e3ynsnlChVGCKt3W1epVDAJbuEnK3nG6CIBGPqTU/EjVCCRS2d4A8PHgA24kihjJiVxIvzgj0nZFTxDtA5sSA8/Xc5ndP68ffqnEzdDi8YkHTrsv+jox+128c/UPGhJgLEZnbgCBKjdbbfgJUNyw1vhewxOvIR5AAFmDWCHvYfJfn5+khu+QTxUWcERK+eFpievHx83alFXatiTI2hVuVIBraCS/N5vA9MaWpOqAJ8XT1c1vnnDeHcAhs6wZmHbcROXC/xEf1aKpaeHR1xZr8o0dq/T5XgI3f/dRInGIhEpngQna6gO++PRqCBPNDDynwWp5MmLjZOoPIbZudv/Rbfrzdvrhd5k5i+NrwOSbqU8ygAAAABJRU5ErkJggg==')",
              "backgroundSize": "cover",
              "display": "block"
            }
          }}></span>{`
  `}<img parentName="span" {...{
            "className": "gatsby-resp-image-image",
            "alt": "Pattern with IBM 8-bar logo",
            "title": "Pattern with IBM 8-bar logo",
            "src": "/workplace-xg/static/031a2a8c1fab78b8f0246a842a6d89c2/a5df1/pattern-with-ibm-8-bar-logo.png",
            "srcSet": ["/workplace-xg/static/031a2a8c1fab78b8f0246a842a6d89c2/7fc1e/pattern-with-ibm-8-bar-logo.png 288w", "/workplace-xg/static/031a2a8c1fab78b8f0246a842a6d89c2/a5df1/pattern-with-ibm-8-bar-logo.png 576w"],
            "sizes": "(max-width: 576px) 100vw, 576px",
            "style": {
              "width": "100%",
              "height": "100%",
              "margin": "0",
              "verticalAlign": "middle",
              "position": "absolute",
              "top": "0",
              "left": "0"
            },
            "loading": "lazy"
          }}></img>{`
    `}</span>
        <Caption mdxType="Caption">Logo pattern by Paul Rand</Caption>
      </Column>
      <Column colLg={4} colMd={4} colSm={4} mdxType="Column">
        <span {...{
          "className": "gatsby-resp-image-wrapper",
          "style": {
            "position": "relative",
            "display": "block",
            "marginLeft": "auto",
            "marginRight": "auto",
            "maxWidth": "576px"
          }
        }}>{`
      `}<span parentName="span" {...{
            "className": "gatsby-resp-image-background-image",
            "style": {
              "paddingBottom": "100%",
              "position": "relative",
              "bottom": "0",
              "left": "0",
              "backgroundImage": "url('data:image/jpeg;base64,/9j/2wBDABALDA4MChAODQ4SERATGCgaGBYWGDEjJR0oOjM9PDkzODdASFxOQERXRTc4UG1RV19iZ2hnPk1xeXBkeFxlZ2P/2wBDARESEhgVGC8aGi9jQjhCY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2P/wgARCAAUABQDASIAAhEBAxEB/8QAGQABAAMBAQAAAAAAAAAAAAAAAAIDBQEE/8QAFAEBAAAAAAAAAAAAAAAAAAAAAP/aAAwDAQACEAMQAAABzZ3esyVwpmHQf//EABwQAAICAgMAAAAAAAAAAAAAAAECAAMEEBESE//aAAgBAQABBQJUZh4vOJRaEi5QAc9n3//EABQRAQAAAAAAAAAAAAAAAAAAACD/2gAIAQMBAT8BH//EABQRAQAAAAAAAAAAAAAAAAAAACD/2gAIAQIBAT8BH//EABwQAQACAQUAAAAAAAAAAAAAAAEAAhARICEyQf/aAAgBAQAGPwLgXSdHFhlSWT3Z/8QAGhABAAMBAQEAAAAAAAAAAAAAAQARMSEQQf/aAAgBAQABPyFQmaogqGpZyLGkpgYdINij7yHilcJXn//aAAwDAQACAAMAAAAQUM8A/8QAFBEBAAAAAAAAAAAAAAAAAAAAIP/aAAgBAwEBPxAf/8QAFBEBAAAAAAAAAAAAAAAAAAAAIP/aAAgBAgEBPxAf/8QAGhABAQEBAQEBAAAAAAAAAAAAAREAITFB0f/aAAgBAQABPxAB5VUDBK8i+mRKBiJE1WF0Qb54TCAThqB+4qG0U+Y3Ameb/9k=')",
              "backgroundSize": "cover",
              "display": "block"
            }
          }}></span>{`
  `}<img parentName="span" {...{
            "className": "gatsby-resp-image-image",
            "alt": "IBM iX®",
            "title": "IBM iX®",
            "src": "/workplace-xg/static/1fa2ca1facff38abae66f9d01ed9f206/473e3/ibm-ix.jpg",
            "srcSet": ["/workplace-xg/static/1fa2ca1facff38abae66f9d01ed9f206/69549/ibm-ix.jpg 288w", "/workplace-xg/static/1fa2ca1facff38abae66f9d01ed9f206/473e3/ibm-ix.jpg 576w"],
            "sizes": "(max-width: 576px) 100vw, 576px",
            "style": {
              "width": "100%",
              "height": "100%",
              "margin": "0",
              "verticalAlign": "middle",
              "position": "absolute",
              "top": "0",
              "left": "0"
            },
            "loading": "lazy"
          }}></img>{`
    `}</span>
        <Caption mdxType="Caption">IBM iX® 3D logo</Caption>
      </Column>
      <Column colLg={4} colMd={4} colSm={4} mdxType="Column">
        <span {...{
          "className": "gatsby-resp-image-wrapper",
          "style": {
            "position": "relative",
            "display": "block",
            "marginLeft": "auto",
            "marginRight": "auto",
            "maxWidth": "576px"
          }
        }}>{`
      `}<span parentName="span" {...{
            "className": "gatsby-resp-image-background-image",
            "style": {
              "paddingBottom": "100%",
              "position": "relative",
              "bottom": "0",
              "left": "0",
              "backgroundImage": "url('data:image/jpeg;base64,/9j/2wBDABALDA4MChAODQ4SERATGCgaGBYWGDEjJR0oOjM9PDkzODdASFxOQERXRTc4UG1RV19iZ2hnPk1xeXBkeFxlZ2P/2wBDARESEhgVGC8aGi9jQjhCY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2P/wgARCAAUABQDASIAAhEBAxEB/8QAGQABAAMBAQAAAAAAAAAAAAAAAAIDBAEF/8QAFAEBAAAAAAAAAAAAAAAAAAAAAP/aAAwDAQACEAMQAAAB86yEDQmK+BsB/8QAGxAAAgMAAwAAAAAAAAAAAAAAAQIAAxEEEyP/2gAIAQEAAQUCh2ItbDW1Ss2wSxeoJ6FeOhn/xAAUEQEAAAAAAAAAAAAAAAAAAAAg/9oACAEDAQE/AR//xAAUEQEAAAAAAAAAAAAAAAAAAAAg/9oACAECAQE/AR//xAAdEAACAgMAAwAAAAAAAAAAAAABAgARISIxEkFx/9oACAEBAAY/Ah4PX2Wy2B7l2wm6YlhisoFZoTkxAwEPez//xAAcEAEAAgIDAQAAAAAAAAAAAAABACERMUFhgXH/2gAIAQEAAT8hoPGrLw5SrM1WNVGwThvHH2Atb7G6wc5Jj0XZEKyt6Yq19p//2gAMAwEAAgADAAAAEJMAAP/EABQRAQAAAAAAAAAAAAAAAAAAACD/2gAIAQMBAT8QH//EABQRAQAAAAAAAAAAAAAAAAAAACD/2gAIAQIBAT8QH//EAB8QAQACAgICAwAAAAAAAAAAAAERIQAxQVFhoXGBwf/aAAgBAQABPxAnHUTNJX4k+shArUhjRJW61iFQrkwEaEjinCBWBtHhaHLZfrEuzgVdrC4bBIM9Af3JSrQkFzFV6yTGloeHrzn/2Q==')",
              "backgroundSize": "cover",
              "display": "block"
            }
          }}></span>{`
  `}<img parentName="span" {...{
            "className": "gatsby-resp-image-image",
            "alt": "Magnetic cores",
            "title": "Magnetic cores",
            "src": "/workplace-xg/static/4dadb0cf943f98eb66dc88a66e376c52/473e3/magnetic-cores.jpg",
            "srcSet": ["/workplace-xg/static/4dadb0cf943f98eb66dc88a66e376c52/69549/magnetic-cores.jpg 288w", "/workplace-xg/static/4dadb0cf943f98eb66dc88a66e376c52/473e3/magnetic-cores.jpg 576w"],
            "sizes": "(max-width: 576px) 100vw, 576px",
            "style": {
              "width": "100%",
              "height": "100%",
              "margin": "0",
              "verticalAlign": "middle",
              "position": "absolute",
              "top": "0",
              "left": "0"
            },
            "loading": "lazy"
          }}></img>{`
    `}</span>
        <Caption mdxType="Caption">Magnetic cores</Caption>
      </Column>
      <Column colLg={4} colMd={4} colSm={4} mdxType="Column">
        <span {...{
          "className": "gatsby-resp-image-wrapper",
          "style": {
            "position": "relative",
            "display": "block",
            "marginLeft": "auto",
            "marginRight": "auto",
            "maxWidth": "576px"
          }
        }}>{`
      `}<span parentName="span" {...{
            "className": "gatsby-resp-image-background-image",
            "style": {
              "paddingBottom": "100%",
              "position": "relative",
              "bottom": "0",
              "left": "0",
              "backgroundImage": "url('data:image/jpeg;base64,/9j/2wBDABALDA4MChAODQ4SERATGCgaGBYWGDEjJR0oOjM9PDkzODdASFxOQERXRTc4UG1RV19iZ2hnPk1xeXBkeFxlZ2P/2wBDARESEhgVGC8aGi9jQjhCY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2P/wgARCAAUABQDASIAAhEBAxEB/8QAGQABAAMBAQAAAAAAAAAAAAAAAAEEBQID/8QAFAEBAAAAAAAAAAAAAAAAAAAAAP/aAAwDAQACEAMQAAABVupM9pCvAeYP/8QAGxAAAgIDAQAAAAAAAAAAAAAAAQMAAgQRExD/2gAIAQEAAQUCYhd4cQ6K7CHqTtksYH3E7X8//8QAFBEBAAAAAAAAAAAAAAAAAAAAIP/aAAgBAwEBPwEf/8QAFBEBAAAAAAAAAAAAAAAAAAAAIP/aAAgBAgEBPwEf/8QAHxAAAgECBwAAAAAAAAAAAAAAAAECEBESISIxUWHB/9oACAEBAAY/Alg0+kne3CNhSuyRm6Pun//EABsQAAMBAQADAAAAAAAAAAAAAAABETEhQVGx/9oACAEBAAE/IWckq5RwDGmsbS2fDge9rvtQ7KNnYzAg3aQ3yf/aAAwDAQACAAMAAAAQswg8/8QAFBEBAAAAAAAAAAAAAAAAAAAAIP/aAAgBAwEBPxAf/8QAFBEBAAAAAAAAAAAAAAAAAAAAIP/aAAgBAgEBPxAf/8QAHRABAAICAwEBAAAAAAAAAAAAAREhAEExUWGR0f/aAAgBAQABPxCyD0WPFd+4eZjIZTmFOMLKhNGQcMvDP6bNXk8J0YQedVisrj0Z8nKdVV47n9xGWi15GWBVn//Z')",
              "backgroundSize": "cover",
              "display": "block"
            }
          }}></span>{`
  `}<img parentName="span" {...{
            "className": "gatsby-resp-image-image",
            "alt": "IBM Pavilion, Expo 58",
            "title": "IBM Pavilion, Expo 58",
            "src": "/workplace-xg/static/ad5df5d604b122985a86b868c4b3d31d/473e3/ibm-pavilion-expo-58.jpg",
            "srcSet": ["/workplace-xg/static/ad5df5d604b122985a86b868c4b3d31d/69549/ibm-pavilion-expo-58.jpg 288w", "/workplace-xg/static/ad5df5d604b122985a86b868c4b3d31d/473e3/ibm-pavilion-expo-58.jpg 576w"],
            "sizes": "(max-width: 576px) 100vw, 576px",
            "style": {
              "width": "100%",
              "height": "100%",
              "margin": "0",
              "verticalAlign": "middle",
              "position": "absolute",
              "top": "0",
              "left": "0"
            },
            "loading": "lazy"
          }}></img>{`
    `}</span>
        <Caption mdxType="Caption">
  IBM Pavilion at Expo 58, Brussels, Belgium
  <br />
  Designed by Eliot Noyes
        </Caption>
      </Column>
    </ImageCollection>
    <h2>{`Perspectives`}</h2>
    <p>{`IBM is a great observer of the working world. Looking for design solutions from multiple vantage points provides an intelligent, informed and strong point of view. We remove anything gratuitous to reveal only what’s essential and impactful. This approach to design encourages new perspectives and delivers uniqueness in everything we do. Perspective can be expressed in architecture in both literal and abstract applications. One-point perspective can create symmetry, balance and a sense of drama. Indirectly, we can also expose structure, material and objects that reveal form and function.`}</p>
    <ImageCollection mdxType="ImageCollection">
      <Column colLg={4} colMd={4} colSm={4} mdxType="Column">
        <span {...{
          "className": "gatsby-resp-image-wrapper",
          "style": {
            "position": "relative",
            "display": "block",
            "marginLeft": "auto",
            "marginRight": "auto",
            "maxWidth": "576px"
          }
        }}>{`
      `}<span parentName="span" {...{
            "className": "gatsby-resp-image-background-image",
            "style": {
              "paddingBottom": "100%",
              "position": "relative",
              "bottom": "0",
              "left": "0",
              "backgroundImage": "url('data:image/jpeg;base64,/9j/2wBDABALDA4MChAODQ4SERATGCgaGBYWGDEjJR0oOjM9PDkzODdASFxOQERXRTc4UG1RV19iZ2hnPk1xeXBkeFxlZ2P/2wBDARESEhgVGC8aGi9jQjhCY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2P/wgARCAAUABQDASIAAhEBAxEB/8QAGQABAAIDAAAAAAAAAAAAAAAAAAECAwQF/8QAFgEBAQEAAAAAAAAAAAAAAAAAAAEC/9oADAMBAAIQAxAAAAHlWtVMyRpSKEx//8QAHhAAAgEEAwEAAAAAAAAAAAAAAAIDARESEwQhMTP/2gAIAQEAAQUCwwZUq6rxrkn16oRy6y5sY9P/xAAVEQEBAAAAAAAAAAAAAAAAAAABEP/aAAgBAwEBPwEhP//EABURAQEAAAAAAAAAAAAAAAAAABAB/9oACAECAQE/ASn/xAAdEAACAgIDAQAAAAAAAAAAAAABEQACECESMUFx/9oACAEBAAY/Ai98ZcgdQuyIKl9+xOn2EcXvzDx//8QAGhABAQEBAQEBAAAAAAAAAAAAAREAITFRkf/aAAgBAQABPyFY4pGYGfR1ZDPPoSFzvhU4KVcv6yjlKauaqr1O3WfFk8wvX3f/2gAMAwEAAgADAAAAEPQ3Pf/EABcRAQEBAQAAAAAAAAAAAAAAAAEAITH/2gAIAQMBAT8QCzPJ7f/EABcRAQADAAAAAAAAAAAAAAAAAAEAECH/2gAIAQIBAT8Qchb/xAAfEAACAgIDAAMAAAAAAAAAAAABEQAhMUFRYXGx4fD/2gAIAQEAAT8QR+9lJQp+wZLZbMSSvV9Q+LIASwC3XMBooMoas/tQsikCJ5GPp+IChi1BMV1UJD1JlkljPMLlzvBv68gQnRIlChc//9k=')",
              "backgroundSize": "cover",
              "display": "block"
            }
          }}></span>{`
  `}<img parentName="span" {...{
            "className": "gatsby-resp-image-image",
            "alt": "IBM Power® server",
            "title": "IBM Power® server",
            "src": "/workplace-xg/static/bee0b21d07a8f97baaa6ad05b7c46863/473e3/ibm-power-server.jpg",
            "srcSet": ["/workplace-xg/static/bee0b21d07a8f97baaa6ad05b7c46863/69549/ibm-power-server.jpg 288w", "/workplace-xg/static/bee0b21d07a8f97baaa6ad05b7c46863/473e3/ibm-power-server.jpg 576w"],
            "sizes": "(max-width: 576px) 100vw, 576px",
            "style": {
              "width": "100%",
              "height": "100%",
              "margin": "0",
              "verticalAlign": "middle",
              "position": "absolute",
              "top": "0",
              "left": "0"
            },
            "loading": "lazy"
          }}></img>{`
    `}</span>
        <Caption mdxType="Caption">IBM Power® server</Caption>
      </Column>
      <Column colLg={4} colMd={4} colSm={4} mdxType="Column">
        <span {...{
          "className": "gatsby-resp-image-wrapper",
          "style": {
            "position": "relative",
            "display": "block",
            "marginLeft": "auto",
            "marginRight": "auto",
            "maxWidth": "576px"
          }
        }}>{`
      `}<span parentName="span" {...{
            "className": "gatsby-resp-image-background-image",
            "style": {
              "paddingBottom": "100%",
              "position": "relative",
              "bottom": "0",
              "left": "0",
              "backgroundImage": "url('data:image/jpeg;base64,/9j/2wBDABALDA4MChAODQ4SERATGCgaGBYWGDEjJR0oOjM9PDkzODdASFxOQERXRTc4UG1RV19iZ2hnPk1xeXBkeFxlZ2P/2wBDARESEhgVGC8aGi9jQjhCY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2P/wgARCAAUABQDASIAAhEBAxEB/8QAFwABAQEBAAAAAAAAAAAAAAAAAAMEBf/EABUBAQEAAAAAAAAAAAAAAAAAAAAB/9oADAMBAAIQAxAAAAHjWlrTnApYMoP/xAAcEAACAgIDAAAAAAAAAAAAAAABAgADBBEQEjL/2gAIAQEAAQUCQbIrB4q9vvpEcoTk2MJ//8QAFBEBAAAAAAAAAAAAAAAAAAAAIP/aAAgBAwEBPwEf/8QAFBEBAAAAAAAAAAAAAAAAAAAAIP/aAAgBAgEBPwEf/8QAHhAAAQMEAwAAAAAAAAAAAAAAAQAQEQISMTJBYoH/2gAIAQEABj8ChV9QwhakeNcMqDy3/8QAGhABAQEBAAMAAAAAAAAAAAAAAQARITFRYf/aAAgBAQABPyEjVkERV8za4NfVv2gXfiYNJixgx5N//9oADAMBAAIAAwAAABB31/3/xAAVEQEBAAAAAAAAAAAAAAAAAAAgIf/aAAgBAwEBPxCD/8QAFREBAQAAAAAAAAAAAAAAAAAAICH/2gAIAQIBAT8Qo//EABsQAQACAgMAAAAAAAAAAAAAAAEAESExQVFx/9oACAEBAAE/EBdURwNM7SDLJNpWlOKUu/TqcygRBtlfWbRGQBRZe5ZNyjizaf/Z')",
              "backgroundSize": "cover",
              "display": "block"
            }
          }}></span>{`
  `}<img parentName="span" {...{
            "className": "gatsby-resp-image-image",
            "alt": "IBM Power® server",
            "title": "IBM Power® server",
            "src": "/workplace-xg/static/2887c0e2851fe296639379b843980021/473e3/ibm-power-server-1.jpg",
            "srcSet": ["/workplace-xg/static/2887c0e2851fe296639379b843980021/69549/ibm-power-server-1.jpg 288w", "/workplace-xg/static/2887c0e2851fe296639379b843980021/473e3/ibm-power-server-1.jpg 576w"],
            "sizes": "(max-width: 576px) 100vw, 576px",
            "style": {
              "width": "100%",
              "height": "100%",
              "margin": "0",
              "verticalAlign": "middle",
              "position": "absolute",
              "top": "0",
              "left": "0"
            },
            "loading": "lazy"
          }}></img>{`
    `}</span>
        <Caption mdxType="Caption">IBM Power® server</Caption>
      </Column>
      <Column colLg={4} colMd={4} colSm={4} mdxType="Column">
        <span {...{
          "className": "gatsby-resp-image-wrapper",
          "style": {
            "position": "relative",
            "display": "block",
            "marginLeft": "auto",
            "marginRight": "auto",
            "maxWidth": "576px"
          }
        }}>{`
      `}<span parentName="span" {...{
            "className": "gatsby-resp-image-background-image",
            "style": {
              "paddingBottom": "100%",
              "position": "relative",
              "bottom": "0",
              "left": "0",
              "backgroundImage": "url('data:image/jpeg;base64,/9j/2wBDABALDA4MChAODQ4SERATGCgaGBYWGDEjJR0oOjM9PDkzODdASFxOQERXRTc4UG1RV19iZ2hnPk1xeXBkeFxlZ2P/2wBDARESEhgVGC8aGi9jQjhCY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2P/wgARCAAUABQDASIAAhEBAxEB/8QAGAABAAMBAAAAAAAAAAAAAAAAAAIEBQP/xAAVAQEBAAAAAAAAAAAAAAAAAAAAAf/aAAwDAQACEAMQAAAB2uUqyXwsaImgF//EABsQAAICAwEAAAAAAAAAAAAAAAECAxEABBAT/9oACAEBAAEFAmNCIseSmk13LcYWPFCc/8QAFBEBAAAAAAAAAAAAAAAAAAAAIP/aAAgBAwEBPwEf/8QAFBEBAAAAAAAAAAAAAAAAAAAAIP/aAAgBAgEBPwEf/8QAHhAAAQMEAwAAAAAAAAAAAAAAIQAQEQECMUFSoeH/2gAIAQEABj8C8Ru6asZR0xW44yG//8QAHBAAAgIDAQEAAAAAAAAAAAAAAREAIRAxUWGR/9oACAEBAAE/Ibtr6jVR8pg7wNplQoa0XMCKABHCIBLbezD/2gAMAwEAAgADAAAAEIfH/P/EABQRAQAAAAAAAAAAAAAAAAAAACD/2gAIAQMBAT8QH//EABQRAQAAAAAAAAAAAAAAAAAAACD/2gAIAQIBAT8QH//EACAQAQACAgIBBQAAAAAAAAAAAAEAESExQVEQYXGRwfH/2gAIAQEAAT8Qvcu6G2fsRC/maBB+9X4fiEgC2OL5mBt06oHZBssyMTutgR+YIc6d1vafWvSAAAAGgn//2Q==')",
              "backgroundSize": "cover",
              "display": "block"
            }
          }}></span>{`
  `}<img parentName="span" {...{
            "className": "gatsby-resp-image-image",
            "alt": "IBM Power® server",
            "title": "IBM Power® server",
            "src": "/workplace-xg/static/bd779979b98485d4fb425320629f93bd/473e3/ibm-power-server-2.jpg",
            "srcSet": ["/workplace-xg/static/bd779979b98485d4fb425320629f93bd/69549/ibm-power-server-2.jpg 288w", "/workplace-xg/static/bd779979b98485d4fb425320629f93bd/473e3/ibm-power-server-2.jpg 576w"],
            "sizes": "(max-width: 576px) 100vw, 576px",
            "style": {
              "width": "100%",
              "height": "100%",
              "margin": "0",
              "verticalAlign": "middle",
              "position": "absolute",
              "top": "0",
              "left": "0"
            },
            "loading": "lazy"
          }}></img>{`
    `}</span>
        <Caption mdxType="Caption">IBM Power® server</Caption>
      </Column>
      <Column colLg={12} colMd={8} colSm={4} mdxType="Column">
        <span {...{
          "className": "gatsby-resp-image-wrapper",
          "style": {
            "position": "relative",
            "display": "block",
            "marginLeft": "auto",
            "marginRight": "auto",
            "maxWidth": "1152px"
          }
        }}>{`
      `}<span parentName="span" {...{
            "className": "gatsby-resp-image-background-image",
            "style": {
              "paddingBottom": "66.66666666666666%",
              "position": "relative",
              "bottom": "0",
              "left": "0",
              "backgroundImage": "url('data:image/jpeg;base64,/9j/2wBDABALDA4MChAODQ4SERATGCgaGBYWGDEjJR0oOjM9PDkzODdASFxOQERXRTc4UG1RV19iZ2hnPk1xeXBkeFxlZ2P/2wBDARESEhgVGC8aGi9jQjhCY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2P/wgARCAANABQDASIAAhEBAxEB/8QAGAAAAwEBAAAAAAAAAAAAAAAAAAEDAgT/xAAUAQEAAAAAAAAAAAAAAAAAAAAB/9oADAMBAAIQAxAAAAHbshidIP8A/8QAGhABAQADAQEAAAAAAAAAAAAAAQACAxIRE//aAAgBAQABBQL5jOojELnNuNkel//EABURAQEAAAAAAAAAAAAAAAAAAAAR/9oACAEDAQE/AVf/xAAVEQEBAAAAAAAAAAAAAAAAAAAAEf/aAAgBAgEBPwFH/8QAHRAAAgEEAwAAAAAAAAAAAAAAAAExAxESITOBkf/aAAgBAQAGPwKGQyDVS3RzPxG3kf/EAB8QAQACAQMFAAAAAAAAAAAAAAEAETEQIVFBYYGR4f/aAAgBAQABPyEXYD2xOo9P2BAHzccxHANtHqVXuUqf/9oADAMBAAIAAwAAABDTz//EABcRAQADAAAAAAAAAAAAAAAAAAABIXH/2gAIAQMBAT8Qm2H/xAAWEQEBAQAAAAAAAAAAAAAAAAABAHH/2gAIAQIBAT8QEtX/xAAgEAEAAQMDBQAAAAAAAAAAAAABEQAhkTFBYVFxgaHw/9oACAEBAAE/EJ5S3Cqy6+ahWBvDnblzWixXUlc1NKa4lDpemD4MUezTV6r/2Q==')",
              "backgroundSize": "cover",
              "display": "block"
            }
          }}></span>{`
  `}<img parentName="span" {...{
            "className": "gatsby-resp-image-image",
            "alt": "IBM Watson® IoT",
            "title": "IBM Watson® IoT",
            "src": "/workplace-xg/static/08f0f33989a49848e302047932812e15/2e753/ibm-watson-iot.jpg",
            "srcSet": ["/workplace-xg/static/08f0f33989a49848e302047932812e15/69549/ibm-watson-iot.jpg 288w", "/workplace-xg/static/08f0f33989a49848e302047932812e15/473e3/ibm-watson-iot.jpg 576w", "/workplace-xg/static/08f0f33989a49848e302047932812e15/2e753/ibm-watson-iot.jpg 1152w", "/workplace-xg/static/08f0f33989a49848e302047932812e15/74f4b/ibm-watson-iot.jpg 1728w", "/workplace-xg/static/08f0f33989a49848e302047932812e15/1ca3f/ibm-watson-iot.jpg 1920w"],
            "sizes": "(max-width: 1152px) 100vw, 1152px",
            "style": {
              "width": "100%",
              "height": "100%",
              "margin": "0",
              "verticalAlign": "middle",
              "position": "absolute",
              "top": "0",
              "left": "0"
            },
            "loading": "lazy"
          }}></img>{`
    `}</span>
        <Caption mdxType="Caption">IBM Watson® IoT offerings, Munich, Germany</Caption>
      </Column>
      <Column colLg={4} colMd={3} colSm={4} mdxType="Column">
        <span {...{
          "className": "gatsby-resp-image-wrapper",
          "style": {
            "position": "relative",
            "display": "block",
            "marginLeft": "auto",
            "marginRight": "auto",
            "maxWidth": "576px"
          }
        }}>{`
      `}<span parentName="span" {...{
            "className": "gatsby-resp-image-background-image",
            "style": {
              "paddingBottom": "100%",
              "position": "relative",
              "bottom": "0",
              "left": "0",
              "backgroundImage": "url('data:image/jpeg;base64,/9j/2wBDABALDA4MChAODQ4SERATGCgaGBYWGDEjJR0oOjM9PDkzODdASFxOQERXRTc4UG1RV19iZ2hnPk1xeXBkeFxlZ2P/2wBDARESEhgVGC8aGi9jQjhCY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2P/wgARCAAUABQDASIAAhEBAxEB/8QAFwABAQEBAAAAAAAAAAAAAAAAAAECBf/EABQBAQAAAAAAAAAAAAAAAAAAAAD/2gAMAwEAAhADEAAAAe/ENAAA/8QAFBABAAAAAAAAAAAAAAAAAAAAMP/aAAgBAQABBQIf/8QAFBEBAAAAAAAAAAAAAAAAAAAAIP/aAAgBAwEBPwEf/8QAFBEBAAAAAAAAAAAAAAAAAAAAIP/aAAgBAgEBPwEf/8QAFBABAAAAAAAAAAAAAAAAAAAAMP/aAAgBAQAGPwIf/8QAGBAAAwEBAAAAAAAAAAAAAAAAAAERECD/2gAIAQEAAT8husguP//aAAwDAQACAAMAAAAQQwg8/8QAFBEBAAAAAAAAAAAAAAAAAAAAIP/aAAgBAwEBPxAf/8QAFBEBAAAAAAAAAAAAAAAAAAAAIP/aAAgBAgEBPxAf/8QAGhABAQEBAAMAAAAAAAAAAAAAAQARIRBBgf/aAAgBAQABPxBxaw7Dv2M+4ck2A8f/2Q==')",
              "backgroundSize": "cover",
              "display": "block"
            }
          }}></span>{`
  `}<img parentName="span" {...{
            "className": "gatsby-resp-image-image",
            "alt": "IBM Quantum platform plan view",
            "title": "IBM Quantum platform plan view",
            "src": "/workplace-xg/static/3d806301867a7285472ef8835cc0f89a/473e3/ibm-q-plan-view.jpg",
            "srcSet": ["/workplace-xg/static/3d806301867a7285472ef8835cc0f89a/69549/ibm-q-plan-view.jpg 288w", "/workplace-xg/static/3d806301867a7285472ef8835cc0f89a/473e3/ibm-q-plan-view.jpg 576w"],
            "sizes": "(max-width: 576px) 100vw, 576px",
            "style": {
              "width": "100%",
              "height": "100%",
              "margin": "0",
              "verticalAlign": "middle",
              "position": "absolute",
              "top": "0",
              "left": "0"
            },
            "loading": "lazy"
          }}></img>{`
    `}</span>
        <Caption mdxType="Caption">IBM Quantum platform plan view</Caption>
      </Column>
      <Column colLg={8} colMd={5} colSm={4} mdxType="Column">
        <span {...{
          "className": "gatsby-resp-image-wrapper",
          "style": {
            "position": "relative",
            "display": "block",
            "marginLeft": "auto",
            "marginRight": "auto",
            "maxWidth": "1152px"
          }
        }}>{`
      `}<span parentName="span" {...{
            "className": "gatsby-resp-image-background-image",
            "style": {
              "paddingBottom": "75%",
              "position": "relative",
              "bottom": "0",
              "left": "0",
              "backgroundImage": "url('data:image/jpeg;base64,/9j/2wBDABALDA4MChAODQ4SERATGCgaGBYWGDEjJR0oOjM9PDkzODdASFxOQERXRTc4UG1RV19iZ2hnPk1xeXBkeFxlZ2P/2wBDARESEhgVGC8aGi9jQjhCY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2P/wgARCAAPABQDASIAAhEBAxEB/8QAFwABAQEBAAAAAAAAAAAAAAAAAAQBA//EABYBAQEBAAAAAAAAAAAAAAAAAAMBAv/aAAwDAQACEAMQAAABmyUp90bU/8QAFxAAAwEAAAAAAAAAAAAAAAAAAQIDEv/aAAgBAQABBQJVm0pTG6CQZGOY627nX//EABgRAAIDAAAAAAAAAAAAAAAAAAABERJB/9oACAEDAQE/AcYrQf/EABgRAAIDAAAAAAAAAAAAAAAAAAABERIy/9oACAECAQE/AXpDpJ//xAAeEAABAwQDAAAAAAAAAAAAAAABABFRAgMQIRIiof/aAAgBAQAGPwIsOJZB6n6wtW/UWhajH//EABsQAAIDAAMAAAAAAAAAAAAAAAERACExYXGR/9oACAEBAAE/ITnsjbmGFlRiJbR3iqXNwgsVvIRoz//aAAwDAQACAAMAAAAQix//xAAWEQEBAQAAAAAAAAAAAAAAAAABEQD/2gAIAQMBAT8QspihXf/EABgRAQADAQAAAAAAAAAAAAAAAAEAESEx/9oACAECAQE/ENU8iCKn/8QAGRABAQEBAQEAAAAAAAAAAAAAAREhAFFx/9oACAEBAAE/ECsUpUg7jzbllVh9ucyNIanzDxs9C6cgaCyq/BzZlh3/2Q==')",
              "backgroundSize": "cover",
              "display": "block"
            }
          }}></span>{`
  `}<img parentName="span" {...{
            "className": "gatsby-resp-image-image",
            "alt": "IBM Quantum on display",
            "title": "IBM Quantum on display",
            "src": "/workplace-xg/static/5734ccdb18c84e1992d46adecc27b818/2e753/ibm-q-on-display.jpg",
            "srcSet": ["/workplace-xg/static/5734ccdb18c84e1992d46adecc27b818/69549/ibm-q-on-display.jpg 288w", "/workplace-xg/static/5734ccdb18c84e1992d46adecc27b818/473e3/ibm-q-on-display.jpg 576w", "/workplace-xg/static/5734ccdb18c84e1992d46adecc27b818/2e753/ibm-q-on-display.jpg 1152w", "/workplace-xg/static/5734ccdb18c84e1992d46adecc27b818/a052a/ibm-q-on-display.jpg 1216w"],
            "sizes": "(max-width: 1152px) 100vw, 1152px",
            "style": {
              "width": "100%",
              "height": "100%",
              "margin": "0",
              "verticalAlign": "middle",
              "position": "absolute",
              "top": "0",
              "left": "0"
            },
            "loading": "lazy"
          }}></img>{`
    `}</span>
        <Caption mdxType="Caption">IBM Quantum platform exhibit</Caption>
      </Column>
      <Column colLg={4} colMd={4} colSm={4} mdxType="Column">
        <span {...{
          "className": "gatsby-resp-image-wrapper",
          "style": {
            "position": "relative",
            "display": "block",
            "marginLeft": "auto",
            "marginRight": "auto",
            "maxWidth": "576px"
          }
        }}>{`
      `}<span parentName="span" {...{
            "className": "gatsby-resp-image-background-image",
            "style": {
              "paddingBottom": "100%",
              "position": "relative",
              "bottom": "0",
              "left": "0",
              "backgroundImage": "url('data:image/jpeg;base64,/9j/2wBDABALDA4MChAODQ4SERATGCgaGBYWGDEjJR0oOjM9PDkzODdASFxOQERXRTc4UG1RV19iZ2hnPk1xeXBkeFxlZ2P/2wBDARESEhgVGC8aGi9jQjhCY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2P/wgARCAAUABQDASIAAhEBAxEB/8QAFwABAQEBAAAAAAAAAAAAAAAAAAIBBP/EABYBAQEBAAAAAAAAAAAAAAAAAAIAAf/aAAwDAQACEAMQAAAB6bkLlUYrAHBb/8QAGRAAAwEBAQAAAAAAAAAAAAAAAAECExIg/9oACAEBAAEFAk6hPs3NLNb8/wD/xAAYEQACAwAAAAAAAAAAAAAAAAAAERATIf/aAAgBAwEBPwGzWOf/xAAXEQADAQAAAAAAAAAAAAAAAAAAEBES/9oACAECAQE/AYaf/8QAGxAAAgEFAAAAAAAAAAAAAAAAABEQEiAxMlH/2gAIAQEABj8CdLccMm1v/8QAHxABAAIBAwUAAAAAAAAAAAAAAQARIRAxYUFRkeHx/9oACAEBAAE/IW4a3V0iF4It2TgkflJg9I2t48E78a//2gAMAwEAAgADAAAAEFAH/f/EABoRAAICAwAAAAAAAAAAAAAAAAERABBhgfD/2gAIAQMBAT8QLkQbi57d/wD/xAAZEQEAAgMAAAAAAAAAAAAAAAARAAEQodH/2gAIAQIBAT8QIShQVrmf/8QAIBABAAMAAQMFAAAAAAAAAAAAAQARITFBUXFhkcHR4f/aAAgBAQABPxAEfY0voJz57SuYLgjYe0VsTda8+YpOvv8AhFVpK3PpL9LfVviIF+Yu0wpvIOdp/9k=')",
              "backgroundSize": "cover",
              "display": "block"
            }
          }}></span>{`
  `}<img parentName="span" {...{
            "className": "gatsby-resp-image-image",
            "alt": "workers on fruit sorting line",
            "title": "workers on fruit sorting line",
            "src": "/workplace-xg/static/bf58bc3186c9646b299626e6eb6ddb5c/473e3/workers-on-fruit-sorting-line.jpg",
            "srcSet": ["/workplace-xg/static/bf58bc3186c9646b299626e6eb6ddb5c/69549/workers-on-fruit-sorting-line.jpg 288w", "/workplace-xg/static/bf58bc3186c9646b299626e6eb6ddb5c/473e3/workers-on-fruit-sorting-line.jpg 576w"],
            "sizes": "(max-width: 576px) 100vw, 576px",
            "style": {
              "width": "100%",
              "height": "100%",
              "margin": "0",
              "verticalAlign": "middle",
              "position": "absolute",
              "top": "0",
              "left": "0"
            },
            "loading": "lazy"
          }}></img>{`
    `}</span>
      </Column>
      <Column colLg={4} colMd={4} colSm={4} mdxType="Column">
        <span {...{
          "className": "gatsby-resp-image-wrapper",
          "style": {
            "position": "relative",
            "display": "block",
            "marginLeft": "auto",
            "marginRight": "auto",
            "maxWidth": "576px"
          }
        }}>{`
      `}<span parentName="span" {...{
            "className": "gatsby-resp-image-background-image",
            "style": {
              "paddingBottom": "100%",
              "position": "relative",
              "bottom": "0",
              "left": "0",
              "backgroundImage": "url('data:image/jpeg;base64,/9j/2wBDABALDA4MChAODQ4SERATGCgaGBYWGDEjJR0oOjM9PDkzODdASFxOQERXRTc4UG1RV19iZ2hnPk1xeXBkeFxlZ2P/2wBDARESEhgVGC8aGi9jQjhCY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2P/wgARCAAUABQDASIAAhEBAxEB/8QAGQABAAMBAQAAAAAAAAAAAAAAAAEDBAIF/8QAFgEBAQEAAAAAAAAAAAAAAAAAAAID/9oADAMBAAIQAxAAAAGyO4zvWqHk3lxlB//EABwQAQADAAIDAAAAAAAAAAAAAAEAAhEDIRITIv/aAAgBAQABBQLECxv1mDD273WeTSHNdlu3/8QAFBEBAAAAAAAAAAAAAAAAAAAAIP/aAAgBAwEBPwEf/8QAFBEBAAAAAAAAAAAAAAAAAAAAIP/aAAgBAgEBPwEf/8QAIBAAAgEEAQUAAAAAAAAAAAAAAAERAgMSISIxQVFhcf/aAAgBAQAGPwLi8qfBqy5OxlacCUUr2Rml9OLOps//xAAeEAEAAgEEAwAAAAAAAAAAAAABABEhUWFxkTFBof/aAAgBAQABPyHLlVhOThh8YdSqgoN94AyL08ksQPdcfI+xB1oQJH00mSq3ef/aAAwDAQACAAMAAAAQpBD/AP/EABgRAAIDAAAAAAAAAAAAAAAAAAABEBFR/9oACAEDAQE/EClqn//EABoRAQABBQAAAAAAAAAAAAAAAAEAEBExUfD/2gAIAQIBAT8QHsS7pr//xAAeEAEAAgICAwEAAAAAAAAAAAABABEhYTFBUXHR8P/aAAgBAQABPxAEauQB+eYudKTa+pl1pkFRojeiLcW3jodlS8OiBTr19ioRhwwW95lsLfXcNKAkQFRLszyrZ//Z')",
              "backgroundSize": "cover",
              "display": "block"
            }
          }}></span>{`
  `}<img parentName="span" {...{
            "className": "gatsby-resp-image-image",
            "alt": "sorted fruit on three conveyor belts",
            "title": "sorted fruit on three conveyor belts",
            "src": "/workplace-xg/static/8f18d0d53ffbe434cb5424de8657ca53/473e3/sorted-fruit-on-three-conveyor-belts.jpg",
            "srcSet": ["/workplace-xg/static/8f18d0d53ffbe434cb5424de8657ca53/69549/sorted-fruit-on-three-conveyor-belts.jpg 288w", "/workplace-xg/static/8f18d0d53ffbe434cb5424de8657ca53/473e3/sorted-fruit-on-three-conveyor-belts.jpg 576w"],
            "sizes": "(max-width: 576px) 100vw, 576px",
            "style": {
              "width": "100%",
              "height": "100%",
              "margin": "0",
              "verticalAlign": "middle",
              "position": "absolute",
              "top": "0",
              "left": "0"
            },
            "loading": "lazy"
          }}></img>{`
    `}</span>
      </Column>
      <Column colLg={4} colMd={4} colSm={4} mdxType="Column">
        <span {...{
          "className": "gatsby-resp-image-wrapper",
          "style": {
            "position": "relative",
            "display": "block",
            "marginLeft": "auto",
            "marginRight": "auto",
            "maxWidth": "576px"
          }
        }}>{`
      `}<span parentName="span" {...{
            "className": "gatsby-resp-image-background-image",
            "style": {
              "paddingBottom": "100%",
              "position": "relative",
              "bottom": "0",
              "left": "0",
              "backgroundImage": "url('data:image/jpeg;base64,/9j/2wBDABALDA4MChAODQ4SERATGCgaGBYWGDEjJR0oOjM9PDkzODdASFxOQERXRTc4UG1RV19iZ2hnPk1xeXBkeFxlZ2P/2wBDARESEhgVGC8aGi9jQjhCY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2P/wgARCAAUABQDASIAAhEBAxEB/8QAGAABAAMBAAAAAAAAAAAAAAAAAAIDBAH/xAAWAQEBAQAAAAAAAAAAAAAAAAAAAQL/2gAMAwEAAhADEAAAAZK+FiAy0jOsWf/EABwQAAICAgMAAAAAAAAAAAAAAAABAxICERMUIv/aAAgBAQABBQKpoqc7FMzsMk8rYsLL/8QAFREBAQAAAAAAAAAAAAAAAAAAEAH/2gAIAQMBAT8BIf/EABQRAQAAAAAAAAAAAAAAAAAAACD/2gAIAQIBAT8BH//EABsQAAEEAwAAAAAAAAAAAAAAAAEAEBFRAtHh/9oACAEBAAY/An23EBYksMpIml//xAAcEAACAwEAAwAAAAAAAAAAAAAAAREhMUFRYXH/2gAIAQEAAT8hXDUFZLCasmtQqY/TWj8cfJDNU+g9bJyKnNqR/9oADAMBAAIAAwAAABBnH/z/xAAXEQADAQAAAAAAAAAAAAAAAAAAARAx/9oACAEDAQE/EKen/8QAFhEBAQEAAAAAAAAAAAAAAAAAAAEQ/9oACAECAQE/EMqP/8QAHxABAAIDAAEFAAAAAAAAAAAAAQARITFBUWGBobHR/9oACAEBAAE/EFrKcePvAhNYxDYPxGgE0aJg7RyIaXmhfQlo1cqD6jEHNTWVe3wcIgAxpu39iMCKKhbS68tT/9k=')",
              "backgroundSize": "cover",
              "display": "block"
            }
          }}></span>{`
  `}<img parentName="span" {...{
            "className": "gatsby-resp-image-image",
            "alt": "fruit moving through automated handling equipment",
            "title": "fruit moving through automated handling equipment",
            "src": "/workplace-xg/static/8da638cfdca3246c76661c601ab41066/473e3/fruit-moving-through-automated-handling-equipment.jpg",
            "srcSet": ["/workplace-xg/static/8da638cfdca3246c76661c601ab41066/69549/fruit-moving-through-automated-handling-equipment.jpg 288w", "/workplace-xg/static/8da638cfdca3246c76661c601ab41066/473e3/fruit-moving-through-automated-handling-equipment.jpg 576w"],
            "sizes": "(max-width: 576px) 100vw, 576px",
            "style": {
              "width": "100%",
              "height": "100%",
              "margin": "0",
              "verticalAlign": "middle",
              "position": "absolute",
              "top": "0",
              "left": "0"
            },
            "loading": "lazy"
          }}></img>{`
    `}</span>
      </Column>
      <Column colLg={8} colMd={5} colSm={4} mdxType="Column">
        <GifPlayer className="video-player" color="dark" mdxType="GifPlayer">
          <video src={SlatGradientLoop} autoPlay="autoplay" loop playsInline muted style={{
            "width": "100%"
          }} />
          <span {...{
            "className": "gatsby-resp-image-wrapper",
            "style": {
              "position": "relative",
              "display": "block",
              "marginLeft": "auto",
              "marginRight": "auto",
              "maxWidth": "1152px"
            }
          }}>{`
      `}<span parentName="span" {...{
              "className": "gatsby-resp-image-background-image",
              "style": {
                "paddingBottom": "56.25%",
                "position": "relative",
                "bottom": "0",
                "left": "0",
                "backgroundImage": "url('data:image/jpeg;base64,/9j/2wBDABALDA4MChAODQ4SERATGCgaGBYWGDEjJR0oOjM9PDkzODdASFxOQERXRTc4UG1RV19iZ2hnPk1xeXBkeFxlZ2P/2wBDARESEhgVGC8aGi9jQjhCY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2P/wgARCAALABQDASIAAhEBAxEB/8QAFgABAQEAAAAAAAAAAAAAAAAAAAID/8QAFQEBAQAAAAAAAAAAAAAAAAAAAAH/2gAMAwEAAhADEAAAAd7kgL//xAAXEAEAAwAAAAAAAAAAAAAAAAABACAh/9oACAEBAAEFAlmV/8QAFBEBAAAAAAAAAAAAAAAAAAAAEP/aAAgBAwEBPwE//8QAFBEBAAAAAAAAAAAAAAAAAAAAEP/aAAgBAgEBPwE//8QAFhAAAwAAAAAAAAAAAAAAAAAAACAx/9oACAEBAAY/Air/AP/EABcQAAMBAAAAAAAAAAAAAAAAAAABESD/2gAIAQEAAT8hgJRcv//aAAwDAQACAAMAAAAQTw//xAAWEQADAAAAAAAAAAAAAAAAAAAQESH/2gAIAQMBAT8QVH//xAAWEQADAAAAAAAAAAAAAAAAAAABEDH/2gAIAQIBAT8QMX//xAAZEAACAwEAAAAAAAAAAAAAAAABEQAQQVH/2gAIAQEAAT8QAuuEbOWq/9k=')",
                "backgroundSize": "cover",
                "display": "block"
              }
            }}></span>{`
  `}<img parentName="span" {...{
              "className": "gatsby-resp-image-image",
              "alt": "360 degree animation of lenticular slat wall",
              "title": "360 degree animation of lenticular slat wall",
              "src": "/workplace-xg/static/ef057274df41ab8f26113965dd17bc6d/2e753/slat.jpg",
              "srcSet": ["/workplace-xg/static/ef057274df41ab8f26113965dd17bc6d/69549/slat.jpg 288w", "/workplace-xg/static/ef057274df41ab8f26113965dd17bc6d/473e3/slat.jpg 576w", "/workplace-xg/static/ef057274df41ab8f26113965dd17bc6d/2e753/slat.jpg 1152w", "/workplace-xg/static/ef057274df41ab8f26113965dd17bc6d/533d0/slat.jpg 1280w"],
              "sizes": "(max-width: 1152px) 100vw, 1152px",
              "style": {
                "width": "100%",
                "height": "100%",
                "margin": "0",
                "verticalAlign": "middle",
                "position": "absolute",
                "top": "0",
                "left": "0"
              },
              "loading": "lazy"
            }}></img>{`
    `}</span>
        </GifPlayer>
      </Column>
      <Column colLg={4} colMd={3} colSm={4} mdxType="Column">
        <span {...{
          "className": "gatsby-resp-image-wrapper",
          "style": {
            "position": "relative",
            "display": "block",
            "marginLeft": "auto",
            "marginRight": "auto",
            "maxWidth": "576px"
          }
        }}>{`
      `}<span parentName="span" {...{
            "className": "gatsby-resp-image-background-image",
            "style": {
              "paddingBottom": "75%",
              "position": "relative",
              "bottom": "0",
              "left": "0",
              "backgroundImage": "url('data:image/jpeg;base64,/9j/2wBDABALDA4MChAODQ4SERATGCgaGBYWGDEjJR0oOjM9PDkzODdASFxOQERXRTc4UG1RV19iZ2hnPk1xeXBkeFxlZ2P/2wBDARESEhgVGC8aGi9jQjhCY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2P/wgARCAAPABQDASIAAhEBAxEB/8QAFwAAAwEAAAAAAAAAAAAAAAAAAAQFAv/EABUBAQEAAAAAAAAAAAAAAAAAAAAB/9oADAMBAAIQAxAAAAFdpekkUyH/xAAaEAEBAAMBAQAAAAAAAAAAAAABAgMREgAE/9oACAEBAAEFAsWhTnyzv5p6u5KnJCX/AP/EABQRAQAAAAAAAAAAAAAAAAAAABD/2gAIAQMBAT8BP//EABQRAQAAAAAAAAAAAAAAAAAAABD/2gAIAQIBAT8BP//EABoQAQACAwEAAAAAAAAAAAAAAAEAERAiYaH/2gAIAQEABj8CqKnk2G+S2Jj/xAAaEAEAAgMBAAAAAAAAAAAAAAABABEhMUFR/9oACAEBAAE/IdjwvgwgBXMJtgvVQOEMWHY4L1P/2gAMAwEAAgADAAAAENj/AP/EABQRAQAAAAAAAAAAAAAAAAAAABD/2gAIAQMBAT8QP//EABQRAQAAAAAAAAAAAAAAAAAAABD/2gAIAQIBAT8QP//EABwQAQEAAwADAQAAAAAAAAAAAAERACExQVFxof/aAAgBAQABPxByo5mB8dHDsA7dfzDpeLQE+TFza0PbiukQjNm8cIoms//Z')",
              "backgroundSize": "cover",
              "display": "block"
            }
          }}></span>{`
  `}<img parentName="span" {...{
            "className": "gatsby-resp-image-image",
            "alt": "Hallway view at Thomas J. Watson Research Center",
            "title": "Hallway view at Thomas J. Watson Research Center",
            "src": "/workplace-xg/static/f251be3c349a19b12d6cd975e00ab23b/473e3/hallway-view-at-thomas-j-watson-research-center.jpg",
            "srcSet": ["/workplace-xg/static/f251be3c349a19b12d6cd975e00ab23b/69549/hallway-view-at-thomas-j-watson-research-center.jpg 288w", "/workplace-xg/static/f251be3c349a19b12d6cd975e00ab23b/473e3/hallway-view-at-thomas-j-watson-research-center.jpg 576w"],
            "sizes": "(max-width: 576px) 100vw, 576px",
            "style": {
              "width": "100%",
              "height": "100%",
              "margin": "0",
              "verticalAlign": "middle",
              "position": "absolute",
              "top": "0",
              "left": "0"
            },
            "loading": "lazy"
          }}></img>{`
    `}</span>
        <Caption mdxType="Caption">
  Thomas J. Watson Research Center,
  <br /> New York
        </Caption>
      </Column>
      <Column colLg={4} colMd={4} colSm={4} mdxType="Column">
        <span {...{
          "className": "gatsby-resp-image-wrapper",
          "style": {
            "position": "relative",
            "display": "block",
            "marginLeft": "auto",
            "marginRight": "auto",
            "maxWidth": "576px"
          }
        }}>{`
      `}<span parentName="span" {...{
            "className": "gatsby-resp-image-background-image",
            "style": {
              "paddingBottom": "100%",
              "position": "relative",
              "bottom": "0",
              "left": "0",
              "backgroundImage": "url('data:image/jpeg;base64,/9j/2wBDABALDA4MChAODQ4SERATGCgaGBYWGDEjJR0oOjM9PDkzODdASFxOQERXRTc4UG1RV19iZ2hnPk1xeXBkeFxlZ2P/2wBDARESEhgVGC8aGi9jQjhCY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2P/wgARCAAUABQDASIAAhEBAxEB/8QAGQABAQADAQAAAAAAAAAAAAAAAAQBAgUD/8QAFgEBAQEAAAAAAAAAAAAAAAAAAAEC/9oADAMBAAIQAxAAAAGb2goI2Wpv0g4gP//EABoQAAIDAQEAAAAAAAAAAAAAAAECAAMSITL/2gAIAQEAAQUCryZYwwTFaOhQaEo92dWf/8QAFhEBAQEAAAAAAAAAAAAAAAAAEQAQ/9oACAEDAQE/AWd//8QAGBEAAgMAAAAAAAAAAAAAAAAAAREAAhD/2gAIAQIBAT8BNQ4hv//EAB0QAAEDBQEAAAAAAAAAAAAAAAEAIVEQESAxMpH/2gAIAQEABj8Cgyuj7QMFcutYf//EABsQAAICAwEAAAAAAAAAAAAAAAABESExQVGh/9oACAEBAAE/IWjtpx0NwXBi6iVp5FDJIatRJtpSJS8QOz//2gAMAwEAAgADAAAAEDfn/P/EABcRAAMBAAAAAAAAAAAAAAAAAAABERD/2gAIAQMBAT8QTwrf/8QAFREBAQAAAAAAAAAAAAAAAAAAESD/2gAIAQIBAT8QMi//xAAfEAEAAwEAAQUBAAAAAAAAAAABABExIZFBUWFxocH/2gAIAQEAAT8QpaHG6hV0a97qNTVNTR6iXrnmKZh8lwRGz8QgRkVWdX+xLvghm9c33kDbVYtM/9k=')",
              "backgroundSize": "cover",
              "display": "block"
            }
          }}></span>{`
  `}<img parentName="span" {...{
            "className": "gatsby-resp-image-image",
            "alt": "IBM data center server banks",
            "title": "IBM data center server banks",
            "src": "/workplace-xg/static/473096f896e6001504fec8b8b2a7c8d1/473e3/ibm-data-center-server-banks.jpg",
            "srcSet": ["/workplace-xg/static/473096f896e6001504fec8b8b2a7c8d1/69549/ibm-data-center-server-banks.jpg 288w", "/workplace-xg/static/473096f896e6001504fec8b8b2a7c8d1/473e3/ibm-data-center-server-banks.jpg 576w"],
            "sizes": "(max-width: 576px) 100vw, 576px",
            "style": {
              "width": "100%",
              "height": "100%",
              "margin": "0",
              "verticalAlign": "middle",
              "position": "absolute",
              "top": "0",
              "left": "0"
            },
            "loading": "lazy"
          }}></img>{`
    `}</span>
        <Caption mdxType="Caption">IBM data center</Caption>
      </Column>
      <Column colLg={4} colMd={4} colSm={4} mdxType="Column">
        <span {...{
          "className": "gatsby-resp-image-wrapper",
          "style": {
            "position": "relative",
            "display": "block",
            "marginLeft": "auto",
            "marginRight": "auto",
            "maxWidth": "576px"
          }
        }}>{`
      `}<span parentName="span" {...{
            "className": "gatsby-resp-image-background-image",
            "style": {
              "paddingBottom": "100%",
              "position": "relative",
              "bottom": "0",
              "left": "0",
              "backgroundImage": "url('data:image/jpeg;base64,/9j/2wBDABALDA4MChAODQ4SERATGCgaGBYWGDEjJR0oOjM9PDkzODdASFxOQERXRTc4UG1RV19iZ2hnPk1xeXBkeFxlZ2P/2wBDARESEhgVGC8aGi9jQjhCY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2P/wgARCAAUABQDASIAAhEBAxEB/8QAGAABAQEBAQAAAAAAAAAAAAAAAAIEAwX/xAAUAQEAAAAAAAAAAAAAAAAAAAAA/9oADAMBAAIQAxAAAAGVybGoeFAdQf/EABsQAAIDAAMAAAAAAAAAAAAAAAECAAMREBIT/9oACAEBAAEFAnHUjMNKiO89ONmwXOo//8QAFBEBAAAAAAAAAAAAAAAAAAAAIP/aAAgBAwEBPwEf/8QAFBEBAAAAAAAAAAAAAAAAAAAAIP/aAAgBAgEBPwEf/8QAGxAAAgEFAAAAAAAAAAAAAAAAABEBECAxcYH/2gAIAQEABj8CMPtZ1Yj/xAAbEAEBAQACAwAAAAAAAAAAAAABABEhMUFhsf/aAAgBAQABPyHxnE935JDrY1J107RbsrZVkCJ7L//aAAwDAQACAAMAAAAQ4AcA/8QAFBEBAAAAAAAAAAAAAAAAAAAAIP/aAAgBAwEBPxAf/8QAFBEBAAAAAAAAAAAAAAAAAAAAIP/aAAgBAgEBPxAf/8QAHBABAAMAAgMAAAAAAAAAAAAAAQARITFhQVGB/9oACAEBAAE/EMJSyx9S4LwXoPkNALAq7KiLorfNMQZCAHGmQBtiEqqyw7DRhxsnU//Z')",
              "backgroundSize": "cover",
              "display": "block"
            }
          }}></span>{`
  `}<img parentName="span" {...{
            "className": "gatsby-resp-image-image",
            "alt": "hallway in IBM North Castle location",
            "title": "hallway in IBM North Castle location",
            "src": "/workplace-xg/static/f7cafc0109f931652c6368fed5fd42e7/473e3/hallway-in-ibm-north-castle-location.jpg",
            "srcSet": ["/workplace-xg/static/f7cafc0109f931652c6368fed5fd42e7/69549/hallway-in-ibm-north-castle-location.jpg 288w", "/workplace-xg/static/f7cafc0109f931652c6368fed5fd42e7/473e3/hallway-in-ibm-north-castle-location.jpg 576w"],
            "sizes": "(max-width: 576px) 100vw, 576px",
            "style": {
              "width": "100%",
              "height": "100%",
              "margin": "0",
              "verticalAlign": "middle",
              "position": "absolute",
              "top": "0",
              "left": "0"
            },
            "loading": "lazy"
          }}></img>{`
    `}</span>
        <Caption mdxType="Caption">IBM North Castle, Armonk, New York</Caption>
      </Column>
      <Column colLg={4} colMd={4} colSm={4} mdxType="Column">
        <span {...{
          "className": "gatsby-resp-image-wrapper",
          "style": {
            "position": "relative",
            "display": "block",
            "marginLeft": "auto",
            "marginRight": "auto",
            "maxWidth": "576px"
          }
        }}>{`
      `}<span parentName="span" {...{
            "className": "gatsby-resp-image-background-image",
            "style": {
              "paddingBottom": "100%",
              "position": "relative",
              "bottom": "0",
              "left": "0",
              "backgroundImage": "url('data:image/jpeg;base64,/9j/2wBDABALDA4MChAODQ4SERATGCgaGBYWGDEjJR0oOjM9PDkzODdASFxOQERXRTc4UG1RV19iZ2hnPk1xeXBkeFxlZ2P/2wBDARESEhgVGC8aGi9jQjhCY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2P/wgARCAAUABQDASIAAhEBAxEB/8QAGAABAQEBAQAAAAAAAAAAAAAAAAUCBAH/xAAVAQEBAAAAAAAAAAAAAAAAAAAAAf/aAAwDAQACEAMQAAABpb4tniSiv0BJB//EABsQAAICAwEAAAAAAAAAAAAAAAIDARIABBEz/9oACAEBAAEFAlsgxt3D2AEtXzWMwTvZEVDuNXF//8QAFBEBAAAAAAAAAAAAAAAAAAAAIP/aAAgBAwEBPwEf/8QAFBEBAAAAAAAAAAAAAAAAAAAAIP/aAAgBAgEBPwEf/8QAHxAAAgAFBQAAAAAAAAAAAAAAAAECAxEhcRAxQVGB/9oACAEBAAY/Aqpm5S7wekyvMViPOrfZ/8QAGRABAQEAAwAAAAAAAAAAAAAAAREAITFB/9oACAEBAAE/IaXcdnpgKCzG0O4u5NfcZhCmJIZAD3nKyLE7O//aAAwDAQACAAMAAAAQOOhA/8QAFBEBAAAAAAAAAAAAAAAAAAAAIP/aAAgBAwEBPxAf/8QAFhEBAQEAAAAAAAAAAAAAAAAAAREg/9oACAECAQE/EAotx//EABsQAQACAwEBAAAAAAAAAAAAAAEAESExUUFx/9oACAEBAAE/EEYOrCJxIBu37FVhNkDy+zsVqxpYSXsuDjQvqAraFr9YQwy7i0HFz//Z')",
              "backgroundSize": "cover",
              "display": "block"
            }
          }}></span>{`
  `}<img parentName="span" {...{
            "className": "gatsby-resp-image-image",
            "alt": "Elevator lobby at IBM Astor Place",
            "title": "Elevator lobby at IBM Astor Place",
            "src": "/workplace-xg/static/ba1e48d86272ad2caa4c2a08259588dd/473e3/elevator-lobby-at-ibm-astor-place.jpg",
            "srcSet": ["/workplace-xg/static/ba1e48d86272ad2caa4c2a08259588dd/69549/elevator-lobby-at-ibm-astor-place.jpg 288w", "/workplace-xg/static/ba1e48d86272ad2caa4c2a08259588dd/473e3/elevator-lobby-at-ibm-astor-place.jpg 576w"],
            "sizes": "(max-width: 576px) 100vw, 576px",
            "style": {
              "width": "100%",
              "height": "100%",
              "margin": "0",
              "verticalAlign": "middle",
              "position": "absolute",
              "top": "0",
              "left": "0"
            },
            "loading": "lazy"
          }}></img>{`
    `}</span>
        <Caption mdxType="Caption">IBM Astor Place, New York City</Caption>
      </Column>
    </ImageCollection>
    <h2>{`Geometry`}</h2>
    <p>{`IBM is fueled by data. We use organizing principles in the design of our systems and software to index data, create efficiency and discover insight. Geometry is an essential tool in the development of these systems and establishes a relationship between parts and pieces that’s expressed with order and clarity. Repeatable systems create greater efficiency and modularity. The IBM 2x Grid is designed as a flexible system that can inform both 2D and 3D design. Use geometry in architecture to develop formal relationships between space, volume, layout and grid. Learn more about the 2x Grid.`}</p>
    <ImageCollection mdxType="ImageCollection">
      <Column colLg={8} colMd={5} colSm={4} mdxType="Column">
        <span {...{
          "className": "gatsby-resp-image-wrapper",
          "style": {
            "position": "relative",
            "display": "block",
            "marginLeft": "auto",
            "marginRight": "auto",
            "maxWidth": "1152px"
          }
        }}>{`
      `}<span parentName="span" {...{
            "className": "gatsby-resp-image-background-image",
            "style": {
              "paddingBottom": "100%",
              "position": "relative",
              "bottom": "0",
              "left": "0",
              "backgroundImage": "url('data:image/jpeg;base64,/9j/2wBDABALDA4MChAODQ4SERATGCgaGBYWGDEjJR0oOjM9PDkzODdASFxOQERXRTc4UG1RV19iZ2hnPk1xeXBkeFxlZ2P/2wBDARESEhgVGC8aGi9jQjhCY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2P/wgARCAAUABQDASIAAhEBAxEB/8QAGAABAAMBAAAAAAAAAAAAAAAAAAMEBQH/xAAVAQEBAAAAAAAAAAAAAAAAAAAAAf/aAAwDAQACEAMQAAABkt4+gSM8lyYXoT//xAAaEAADAAMBAAAAAAAAAAAAAAABAgMABBET/9oACAEBAAEFAtepo9zxBdQslaR9BglRs1aNaaqCzcTP/8QAFBEBAAAAAAAAAAAAAAAAAAAAIP/aAAgBAwEBPwEf/8QAFBEBAAAAAAAAAAAAAAAAAAAAIP/aAAgBAgEBPwEf/8QAIBAAAgIBAwUAAAAAAAAAAAAAAAEREiECMXEDIjJSYf/aAAgBAQAGPwJS+4zrrkWbfTZp+x425J6dajubRwQkj//EAB0QAAMAAgIDAAAAAAAAAAAAAAABESExQVFhgdH/2gAIAQEAAT8hq1SrmoLVRXFTyKB6vYoHGeHwXQ4KqWtphangckNpypGOo3YoUKcn/9oADAMBAAIAAwAAABAzGD3/xAAUEQEAAAAAAAAAAAAAAAAAAAAg/9oACAEDAQE/EB//xAAUEQEAAAAAAAAAAAAAAAAAAAAg/9oACAECAQE/EB//xAAfEAEAAgICAgMAAAAAAAAAAAABESEAMVFxQWGBkdH/2gAIAQEAAT8QYEINoQaTRce8jkgoSn838Y61B1+2UNhDYZCBRoRvERKgE8gu2bScMmW5JV7Q8duObo+KcuMbBoB77wteKQXP/9k=')",
              "backgroundSize": "cover",
              "display": "block"
            }
          }}></span>{`
  `}<img parentName="span" {...{
            "className": "gatsby-resp-image-image",
            "alt": "IBM Pavilion model",
            "title": "IBM Pavilion model",
            "src": "/workplace-xg/static/4355a823d0137a3862e4d570e6e83c81/2e753/ibm-pavilion.jpg",
            "srcSet": ["/workplace-xg/static/4355a823d0137a3862e4d570e6e83c81/69549/ibm-pavilion.jpg 288w", "/workplace-xg/static/4355a823d0137a3862e4d570e6e83c81/473e3/ibm-pavilion.jpg 576w", "/workplace-xg/static/4355a823d0137a3862e4d570e6e83c81/2e753/ibm-pavilion.jpg 1152w", "/workplace-xg/static/4355a823d0137a3862e4d570e6e83c81/a052a/ibm-pavilion.jpg 1216w"],
            "sizes": "(max-width: 1152px) 100vw, 1152px",
            "style": {
              "width": "100%",
              "height": "100%",
              "margin": "0",
              "verticalAlign": "middle",
              "position": "absolute",
              "top": "0",
              "left": "0"
            },
            "loading": "lazy"
          }}></img>{`
    `}</span>
        <Caption mdxType="Caption">
  The design of the IBM Pavilion at the 1964 New York World’s Fair employed many
  principles of geometry to create a multimedia experience for guests. The ovoid
  theater, inspired by the IBM Selectric type head, was specifically designed to
  enable multiple projection angles on different surfaces, creating an immersive
  experience for the audience.
        </Caption>
      </Column>
      <Column colLg={4} colMd={3} colSm={4} mdxType="Column">
        <span {...{
          "className": "gatsby-resp-image-wrapper",
          "style": {
            "position": "relative",
            "display": "block",
            "marginLeft": "auto",
            "marginRight": "auto",
            "maxWidth": "576px"
          }
        }}>{`
      `}<span parentName="span" {...{
            "className": "gatsby-resp-image-background-image",
            "style": {
              "paddingBottom": "100%",
              "position": "relative",
              "bottom": "0",
              "left": "0",
              "backgroundImage": "url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAUCAIAAAAC64paAAAACXBIWXMAAAsSAAALEgHS3X78AAABvklEQVQ4y2NgYmUjGzEMPs3MbOxoDOI0A1WzsLJwcLHzCbJzcLIARVjAggQ1A+1hZGHh4OTk5OJmAAMOTi52Tk6ibAZqBmowtXeNSs1z9A41dgkMjs/SNrYCCrKws+PTDNLJyGhu65LXNDk9u6Cjo6ule0JeZUNwWqmGniEDMzOa4xlQdTIJior1TJ41aeb8SZOmTZ85b+a8pZ0TZzY2t1bV1olKSLKwcwqKirNycDKysCI0M7KwsXFysnGymVtZ9k6a3j9l1syZcxev2LB64+6p85aVVzdk5hYYmhgzsbGysHOg2ww1iZHRy9ervrGuvaNtUn/vzNlzZsya09bVHZecGhGfaGNvx8DCghxzDBCdbFzcXLx8DMwspubm5RXl9Q1106dMnDChp7yiJCYlzTs4Ij4pWVtPDxhs2DRzgjQDGZLS0hnpqZVVVbk5uWlpGeGxia5+IfauHtHR0QLCogxMzOiaIfohCMg2NTeLj4vJyczISEkKiwi3tLGxsLRSVlUFuplwCmNgYAQGO9AGPgFBbl5+oInAsAAiopInMCaAQcoMRBxcwJTGCmSwsSMHMjG5ih0c+aRmjCFQGAAAXrRoOBBAuhYAAAAASUVORK5CYII=')",
              "backgroundSize": "cover",
              "display": "block"
            }
          }}></span>{`
  `}<img parentName="span" {...{
            "className": "gatsby-resp-image-image",
            "alt": "IBM Selectric type head",
            "title": "IBM Selectric type head",
            "src": "/workplace-xg/static/79d34e819907604ab57d711e042420f1/a5df1/ibm-selectric-type-element.png",
            "srcSet": ["/workplace-xg/static/79d34e819907604ab57d711e042420f1/7fc1e/ibm-selectric-type-element.png 288w", "/workplace-xg/static/79d34e819907604ab57d711e042420f1/a5df1/ibm-selectric-type-element.png 576w"],
            "sizes": "(max-width: 576px) 100vw, 576px",
            "style": {
              "width": "100%",
              "height": "100%",
              "margin": "0",
              "verticalAlign": "middle",
              "position": "absolute",
              "top": "0",
              "left": "0"
            },
            "loading": "lazy"
          }}></img>{`
    `}</span>
        <Caption mdxType="Caption">IBM Selectric type head, 1961</Caption>
      </Column>
      <Column colLg={6} colMd={4} colSm={4} mdxType="Column">
        <span {...{
          "className": "gatsby-resp-image-wrapper",
          "style": {
            "position": "relative",
            "display": "block",
            "marginLeft": "auto",
            "marginRight": "auto",
            "maxWidth": "896px"
          }
        }}>{`
      `}<span parentName="span" {...{
            "className": "gatsby-resp-image-background-image",
            "style": {
              "paddingBottom": "100%",
              "position": "relative",
              "bottom": "0",
              "left": "0",
              "backgroundImage": "url('data:image/jpeg;base64,/9j/2wBDABALDA4MChAODQ4SERATGCgaGBYWGDEjJR0oOjM9PDkzODdASFxOQERXRTc4UG1RV19iZ2hnPk1xeXBkeFxlZ2P/2wBDARESEhgVGC8aGi9jQjhCY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2P/wgARCAAUABQDASIAAhEBAxEB/8QAGAABAQEBAQAAAAAAAAAAAAAAAAMCBAX/xAAWAQEBAQAAAAAAAAAAAAAAAAABAgD/2gAMAwEAAhADEAAAAfFrrTPCuS1wriBv/8QAHRAAAgIBBQAAAAAAAAAAAAAAAQIAAxEQEiEiMf/aAAgBAQABBQJFLQ1WaLwO0Ptbmbzgu2f/xAAWEQEBAQAAAAAAAAAAAAAAAAARABD/2gAIAQMBAT8BZ3//xAAWEQADAAAAAAAAAAAAAAAAAAAAEBH/2gAIAQIBAT8BI//EAB0QAAECBwAAAAAAAAAAAAAAAAABMQIQESAhIjP/2gAIAQEABj8C1SpzilhLFYc//8QAHBAAAwADAAMAAAAAAAAAAAAAAAERITFRQXHh/9oACAEBAAE/IW8a/EQVonUMvyAtsPdF4Lcu+z5gY2H/2gAMAwEAAgADAAAAECvYQ//EABcRAQADAAAAAAAAAAAAAAAAAAEAEBH/2gAIAQMBAT8QNCwv/8QAFhEBAQEAAAAAAAAAAAAAAAAAAREg/9oACAECAQE/EEjMf//EABwQAQACAgMBAAAAAAAAAAAAAAEAESExQXGRof/aAAgBAQABPxBoGZpth2F2cBBTUvBOWSMbwt3mtS1N/IutM0ZV7F7PjGCu9z//2Q==')",
              "backgroundSize": "cover",
              "display": "block"
            }
          }}></span>{`
  `}<img parentName="span" {...{
            "className": "gatsby-resp-image-image",
            "alt": "IBM Quantum System One computer",
            "title": "IBM Quantum System One computer",
            "src": "/workplace-xg/static/ef29c85b8087ab6186b5ca12628ca5a5/968f2/ibm-q-system-one-computer.jpg",
            "srcSet": ["/workplace-xg/static/ef29c85b8087ab6186b5ca12628ca5a5/69549/ibm-q-system-one-computer.jpg 288w", "/workplace-xg/static/ef29c85b8087ab6186b5ca12628ca5a5/473e3/ibm-q-system-one-computer.jpg 576w", "/workplace-xg/static/ef29c85b8087ab6186b5ca12628ca5a5/968f2/ibm-q-system-one-computer.jpg 896w"],
            "sizes": "(max-width: 896px) 100vw, 896px",
            "style": {
              "width": "100%",
              "height": "100%",
              "margin": "0",
              "verticalAlign": "middle",
              "position": "absolute",
              "top": "0",
              "left": "0"
            },
            "loading": "lazy"
          }}></img>{`
    `}</span>
        <Caption mdxType="Caption">
  IBM Quantum System One computer, 2018 <br /> Geometry has always played a
  critical role in the design of IBM systems, both past and present. These
  principles can also inform architectural design and planning.
        </Caption>
      </Column>
      <Column colLg={6} colMd={4} colSm={4} mdxType="Column">
        <span {...{
          "className": "gatsby-resp-image-wrapper",
          "style": {
            "position": "relative",
            "display": "block",
            "marginLeft": "auto",
            "marginRight": "auto",
            "maxWidth": "896px"
          }
        }}>{`
      `}<span parentName="span" {...{
            "className": "gatsby-resp-image-background-image",
            "style": {
              "paddingBottom": "100%",
              "position": "relative",
              "bottom": "0",
              "left": "0",
              "backgroundImage": "url('data:image/jpeg;base64,/9j/2wBDABALDA4MChAODQ4SERATGCgaGBYWGDEjJR0oOjM9PDkzODdASFxOQERXRTc4UG1RV19iZ2hnPk1xeXBkeFxlZ2P/2wBDARESEhgVGC8aGi9jQjhCY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2P/wgARCAAUABQDASIAAhEBAxEB/8QAGQABAAMBAQAAAAAAAAAAAAAAAAECAwQF/8QAFgEBAQEAAAAAAAAAAAAAAAAAAAMC/9oADAMBAAIQAxAAAAGMs+SkfXUblaQgH//EABoQAAICAwAAAAAAAAAAAAAAAAECABADEyH/2gAIAQEAAQUCZgs3JWcwiA8v/8QAFhEBAQEAAAAAAAAAAAAAAAAAAQIg/9oACAEDAQE/ASRMf//EABURAQEAAAAAAAAAAAAAAAAAAAEg/9oACAECAQE/AVY//8QAGxAAAgEFAAAAAAAAAAAAAAAAAAEQESAhIkH/2gAIAQEABj8CydhUQtbf/8QAHRAAAgIBBQAAAAAAAAAAAAAAAAERUSEQMWGBwf/aAAgBAQABPyFCnLoeLwbjGlkGRw0zCIVEKtP/2gAMAwEAAgADAAAAEBg4/wD/xAAWEQEBAQAAAAAAAAAAAAAAAAABABD/2gAIAQMBAT8QILO//8QAFhEBAQEAAAAAAAAAAAAAAAAAASAh/9oACAECAQE/EBOR/8QAHRABAAICAgMAAAAAAAAAAAAAAQARITFRkUFhwf/aAAgBAQABPxA0EPDUHk5lyUBNJZMICt4WtcTFLfYwnRgCHA6noSg8HU//2Q==')",
              "backgroundSize": "cover",
              "display": "block"
            }
          }}></span>{`
  `}<img parentName="span" {...{
            "className": "gatsby-resp-image-image",
            "alt": "IBM 1401 Data Processing Unit",
            "title": "IBM 1401 Data Processing Unit",
            "src": "/workplace-xg/static/20216ded903df2beac3afa5e531ab922/968f2/ibm-1401-data-processing-unit.jpg",
            "srcSet": ["/workplace-xg/static/20216ded903df2beac3afa5e531ab922/69549/ibm-1401-data-processing-unit.jpg 288w", "/workplace-xg/static/20216ded903df2beac3afa5e531ab922/473e3/ibm-1401-data-processing-unit.jpg 576w", "/workplace-xg/static/20216ded903df2beac3afa5e531ab922/968f2/ibm-1401-data-processing-unit.jpg 896w"],
            "sizes": "(max-width: 896px) 100vw, 896px",
            "style": {
              "width": "100%",
              "height": "100%",
              "margin": "0",
              "verticalAlign": "middle",
              "position": "absolute",
              "top": "0",
              "left": "0"
            },
            "loading": "lazy"
          }}></img>{`
    `}</span>
        <Caption mdxType="Caption">IBM 1401 Data Processing System, 1959</Caption>
      </Column>
      <Column colLg={4} colMd={3} colSm={4} mdxType="Column">
        <span {...{
          "className": "gatsby-resp-image-wrapper",
          "style": {
            "position": "relative",
            "display": "block",
            "marginLeft": "auto",
            "marginRight": "auto",
            "maxWidth": "576px"
          }
        }}>{`
      `}<span parentName="span" {...{
            "className": "gatsby-resp-image-background-image",
            "style": {
              "paddingBottom": "100%",
              "position": "relative",
              "bottom": "0",
              "left": "0",
              "backgroundImage": "url('data:image/jpeg;base64,/9j/2wBDABALDA4MChAODQ4SERATGCgaGBYWGDEjJR0oOjM9PDkzODdASFxOQERXRTc4UG1RV19iZ2hnPk1xeXBkeFxlZ2P/2wBDARESEhgVGC8aGi9jQjhCY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2P/wgARCAAUABQDASIAAhEBAxEB/8QAGAABAQEBAQAAAAAAAAAAAAAAAAIDBAX/xAAVAQEBAAAAAAAAAAAAAAAAAAAAAf/aAAwDAQACEAMQAAAB9jHfEtKOqCqEf//EABsQAAICAwEAAAAAAAAAAAAAAAABAhEDEBIy/9oACAEBAAEFAsraF0i7J6h5asUEcn//xAAUEQEAAAAAAAAAAAAAAAAAAAAg/9oACAEDAQE/AR//xAAUEQEAAAAAAAAAAAAAAAAAAAAg/9oACAECAQE/AR//xAAaEAABBQEAAAAAAAAAAAAAAAABABARICJB/9oACAEBAAY/AhC0X7X/xAAbEAEAAgMBAQAAAAAAAAAAAAABABEhMUFRgf/aAAgBAQABPyEQG1mYjUCLLqc1ueqfUCZdzA2gJSf/2gAMAwEAAgADAAAAEHAnPv/EABQRAQAAAAAAAAAAAAAAAAAAACD/2gAIAQMBAT8QH//EABQRAQAAAAAAAAAAAAAAAAAAACD/2gAIAQIBAT8QH//EAB8QAQEAAQQCAwAAAAAAAAAAAAERACExUWFBcYGR4f/aAAgBAQABPxCwBTXY7w2R6w+OcMVLamJGBQy6GaBVB4bdH5giIpjiuHw0M1IGvee37z//2Q==')",
              "backgroundSize": "cover",
              "display": "block"
            }
          }}></span>{`
  `}<img parentName="span" {...{
            "className": "gatsby-resp-image-image",
            "alt": "IBM North Castle, NY plan view",
            "title": "IBM North Castle, NY plan view",
            "src": "/workplace-xg/static/f585c4dae22eb15414d79fc8288a98b2/473e3/ibm-north-castle-ny-plan-view.jpg",
            "srcSet": ["/workplace-xg/static/f585c4dae22eb15414d79fc8288a98b2/69549/ibm-north-castle-ny-plan-view.jpg 288w", "/workplace-xg/static/f585c4dae22eb15414d79fc8288a98b2/473e3/ibm-north-castle-ny-plan-view.jpg 576w"],
            "sizes": "(max-width: 576px) 100vw, 576px",
            "style": {
              "width": "100%",
              "height": "100%",
              "margin": "0",
              "verticalAlign": "middle",
              "position": "absolute",
              "top": "0",
              "left": "0"
            },
            "loading": "lazy"
          }}></img>{`
    `}</span>
        <Caption mdxType="Caption">IBM North Castle, New York</Caption>
      </Column>
      <Column colLg={8} colMd={5} colSm={4} mdxType="Column">
        <span {...{
          "className": "gatsby-resp-image-wrapper",
          "style": {
            "position": "relative",
            "display": "block",
            "marginLeft": "auto",
            "marginRight": "auto",
            "maxWidth": "1152px"
          }
        }}>{`
      `}<span parentName="span" {...{
            "className": "gatsby-resp-image-background-image",
            "style": {
              "paddingBottom": "75%",
              "position": "relative",
              "bottom": "0",
              "left": "0",
              "backgroundImage": "url('data:image/jpeg;base64,/9j/2wBDABALDA4MChAODQ4SERATGCgaGBYWGDEjJR0oOjM9PDkzODdASFxOQERXRTc4UG1RV19iZ2hnPk1xeXBkeFxlZ2P/2wBDARESEhgVGC8aGi9jQjhCY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2P/wgARCAAPABQDASIAAhEBAxEB/8QAFwAAAwEAAAAAAAAAAAAAAAAAAAIDBP/EABUBAQEAAAAAAAAAAAAAAAAAAAEA/9oADAMBAAIQAxAAAAHeklHQSC//xAAZEAADAQEBAAAAAAAAAAAAAAABAgMRABL/2gAIAQEAAQUCGMDPgg5403zYBVrn/8QAFBEBAAAAAAAAAAAAAAAAAAAAEP/aAAgBAwEBPwE//8QAFBEBAAAAAAAAAAAAAAAAAAAAEP/aAAgBAgEBPwE//8QAHBAAAgEFAQAAAAAAAAAAAAAAABECECEiMZGh/9oACAEBAAY/AjflMUhKPS8uH//EABkQAQEBAQEBAAAAAAAAAAAAAAERADEhcf/aAAgBAQABPyFUDSyzA/WSeNm7B3x0wBMKrDeRv//aAAwDAQACAAMAAAAQYy//xAAVEQEBAAAAAAAAAAAAAAAAAAAAEf/aAAgBAwEBPxBH/8QAFhEBAQEAAAAAAAAAAAAAAAAAAAER/9oACAECAQE/EK2P/8QAHBABAQACAwEBAAAAAAAAAAAAAREAITFBgXGx/9oACAEBAAE/EHbBoUx8wNBhDtdZQNhLJ+4lbcZzn55kWygim+e8qAqFAHpn/9k=')",
              "backgroundSize": "cover",
              "display": "block"
            }
          }}></span>{`
  `}<img parentName="span" {...{
            "className": "gatsby-resp-image-image",
            "alt": "IBM North Castle, NY interior view",
            "title": "IBM North Castle, NY interior view",
            "src": "/workplace-xg/static/8bafb82b00808e8060bdca9420982d67/2e753/ibm-north-castle-ny-interior-view.jpg",
            "srcSet": ["/workplace-xg/static/8bafb82b00808e8060bdca9420982d67/69549/ibm-north-castle-ny-interior-view.jpg 288w", "/workplace-xg/static/8bafb82b00808e8060bdca9420982d67/473e3/ibm-north-castle-ny-interior-view.jpg 576w", "/workplace-xg/static/8bafb82b00808e8060bdca9420982d67/2e753/ibm-north-castle-ny-interior-view.jpg 1152w", "/workplace-xg/static/8bafb82b00808e8060bdca9420982d67/a052a/ibm-north-castle-ny-interior-view.jpg 1216w"],
            "sizes": "(max-width: 1152px) 100vw, 1152px",
            "style": {
              "width": "100%",
              "height": "100%",
              "margin": "0",
              "verticalAlign": "middle",
              "position": "absolute",
              "top": "0",
              "left": "0"
            },
            "loading": "lazy"
          }}></img>{`
    `}</span>
        <Caption mdxType="Caption">IBM North Castle, New York</Caption>
      </Column>
      <Column colLg={8} colMd={5} colSm={4} mdxType="Column">
        <span {...{
          "className": "gatsby-resp-image-wrapper",
          "style": {
            "position": "relative",
            "display": "block",
            "marginLeft": "auto",
            "marginRight": "auto",
            "maxWidth": "1152px"
          }
        }}>{`
      `}<span parentName="span" {...{
            "className": "gatsby-resp-image-background-image",
            "style": {
              "paddingBottom": "75%",
              "position": "relative",
              "bottom": "0",
              "left": "0",
              "backgroundImage": "url('data:image/jpeg;base64,/9j/2wBDABALDA4MChAODQ4SERATGCgaGBYWGDEjJR0oOjM9PDkzODdASFxOQERXRTc4UG1RV19iZ2hnPk1xeXBkeFxlZ2P/2wBDARESEhgVGC8aGi9jQjhCY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2P/wgARCAAPABQDASIAAhEBAxEB/8QAGAAAAwEBAAAAAAAAAAAAAAAAAAIEAQP/xAAVAQEBAAAAAAAAAAAAAAAAAAABAv/aAAwDAQACEAMQAAAB2mdopDiJ/8QAGRAAAgMBAAAAAAAAAAAAAAAAAQIAAxES/9oACAEBAAEFAja06jjpjXscErtgP//EABURAQEAAAAAAAAAAAAAAAAAABAR/9oACAEDAQE/AYf/xAAVEQEBAAAAAAAAAAAAAAAAAAAQEf/aAAgBAgEBPwGn/8QAGxAAAgIDAQAAAAAAAAAAAAAAAAERIQISIjH/2gAIAQEABj8CVY+lo6bQuhascwf/xAAaEAACAwEBAAAAAAAAAAAAAAABEQAhMUFx/9oACAEBAAE/IWUuTpgM4v3Y9PBAEziCLgYI3pPJq66n/9oADAMBAAIAAwAAABDL/wD/xAAWEQEBAQAAAAAAAAAAAAAAAAAAASH/2gAIAQMBAT8Qtsf/xAAWEQEBAQAAAAAAAAAAAAAAAAABABH/2gAIAQIBAT8QCzt//8QAHRABAAICAgMAAAAAAAAAAAAAAREhADFBkWFx8f/aAAgBAQABPxA0Igatl9ayAgcW5tqvGS0BCcEfVxJgRRHvXeHGAzK2syOSFqbrjnP/2Q==')",
              "backgroundSize": "cover",
              "display": "block"
            }
          }}></span>{`
  `}<img parentName="span" {...{
            "className": "gatsby-resp-image-image",
            "alt": "enclosed meeting room near open collaboration zone",
            "title": "enclosed meeting room near open collaboration zone",
            "src": "/workplace-xg/static/ddde7fada04322075ebdd44c543b043e/2e753/enclosed-meeting-room-near-open-collaboration-zone.jpg",
            "srcSet": ["/workplace-xg/static/ddde7fada04322075ebdd44c543b043e/69549/enclosed-meeting-room-near-open-collaboration-zone.jpg 288w", "/workplace-xg/static/ddde7fada04322075ebdd44c543b043e/473e3/enclosed-meeting-room-near-open-collaboration-zone.jpg 576w", "/workplace-xg/static/ddde7fada04322075ebdd44c543b043e/2e753/enclosed-meeting-room-near-open-collaboration-zone.jpg 1152w", "/workplace-xg/static/ddde7fada04322075ebdd44c543b043e/a052a/enclosed-meeting-room-near-open-collaboration-zone.jpg 1216w"],
            "sizes": "(max-width: 1152px) 100vw, 1152px",
            "style": {
              "width": "100%",
              "height": "100%",
              "margin": "0",
              "verticalAlign": "middle",
              "position": "absolute",
              "top": "0",
              "left": "0"
            },
            "loading": "lazy"
          }}></img>{`
    `}</span>
      </Column>
      <Column colLg={4} colMd={3} colSm={4} mdxType="Column">
        <span {...{
          "className": "gatsby-resp-image-wrapper",
          "style": {
            "position": "relative",
            "display": "block",
            "marginLeft": "auto",
            "marginRight": "auto",
            "maxWidth": "576px"
          }
        }}>{`
      `}<span parentName="span" {...{
            "className": "gatsby-resp-image-background-image",
            "style": {
              "paddingBottom": "181.94444444444443%",
              "position": "relative",
              "bottom": "0",
              "left": "0",
              "backgroundImage": "url('data:image/jpeg;base64,/9j/2wBDABALDA4MChAODQ4SERATGCgaGBYWGDEjJR0oOjM9PDkzODdASFxOQERXRTc4UG1RV19iZ2hnPk1xeXBkeFxlZ2P/2wBDARESEhgVGC8aGi9jQjhCY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2P/wgARCAAkABQDASIAAhEBAxEB/8QAGAABAAMBAAAAAAAAAAAAAAAAAAECAwX/xAAUAQEAAAAAAAAAAAAAAAAAAAAA/9oADAMBAAIQAxAAAAHu1DRAyrepsCYCQf/EABwQAAICAwEBAAAAAAAAAAAAAAACATEQESEDEv/aAAgBAQABBQKZ0fWGGIp476cFprbpFGsf/8QAFBEBAAAAAAAAAAAAAAAAAAAAIP/aAAgBAwEBPwFf/8QAFBEBAAAAAAAAAAAAAAAAAAAAIP/aAAgBAgEBPwFf/8QAFhABAQEAAAAAAAAAAAAAAAAAASAA/9oACAEBAAY/ArMX/8QAHBAAAwACAwEAAAAAAAAAAAAAAAERITEQUYGh/9oACAEBAAE/IbjyLKErEWKaCiMwQfEXEEaKpOGgaTI64//aAAwDAQACAAMAAAAQIM4MA8//xAAUEQEAAAAAAAAAAAAAAAAAAAAg/9oACAEDAQE/EF//xAAUEQEAAAAAAAAAAAAAAAAAAAAg/9oACAECAQE/EF//xAAeEAEAAgICAwEAAAAAAAAAAAABABEhMUFRYXGBof/aAAgBAQABPxCiFCzFyhtrHS9wMoNHMo1FPfyfgjGPFPrMutb3ZfUtm3SYwiJTZqBlg69eYaLoilpc8aAABqf/2Q==')",
              "backgroundSize": "cover",
              "display": "block"
            }
          }}></span>{`
  `}<img parentName="span" {...{
            "className": "gatsby-resp-image-image",
            "alt": "IBM North Castle",
            "title": "IBM North Castle",
            "src": "/workplace-xg/static/2cf6cd7d879f9c81f211d730e9566ee6/473e3/ibm-north-castle.jpg",
            "srcSet": ["/workplace-xg/static/2cf6cd7d879f9c81f211d730e9566ee6/69549/ibm-north-castle.jpg 288w", "/workplace-xg/static/2cf6cd7d879f9c81f211d730e9566ee6/473e3/ibm-north-castle.jpg 576w"],
            "sizes": "(max-width: 576px) 100vw, 576px",
            "style": {
              "width": "100%",
              "height": "100%",
              "margin": "0",
              "verticalAlign": "middle",
              "position": "absolute",
              "top": "0",
              "left": "0"
            },
            "loading": "lazy"
          }}></img>{`
    `}</span>
        <Caption mdxType="Caption">IBM North Castle, New York renovated floor plan, 2017</Caption>
      </Column>
    </ImageCollection>
    <h2>{`Duality`}</h2>
    <p>{`IBM has always served as a medium between mankind and machine. This relationship is the basis of our brand and every experience with IBM. It’s this dynamic that we’re designing when we design anything. This duality can drive design choices—drawing parallels between the organic and engineered, light and dark, or soft and hard. We seek to pull the outside world in, through biophilic design and thoughtful contrast in material palette. We invite our design partners to explore how this relationship can manifest locally, drawing on regional influence to help inform dynamic design solutions.`}</p>
    <ImageCollection mdxType="ImageCollection">
      <Column colLg={8} colMd={5} colSm={4} mdxType="Column">
        <span {...{
          "className": "gatsby-resp-image-wrapper",
          "style": {
            "position": "relative",
            "display": "block",
            "marginLeft": "auto",
            "marginRight": "auto",
            "maxWidth": "1152px"
          }
        }}>{`
      `}<span parentName="span" {...{
            "className": "gatsby-resp-image-background-image",
            "style": {
              "paddingBottom": "75%",
              "position": "relative",
              "bottom": "0",
              "left": "0",
              "backgroundImage": "url('data:image/jpeg;base64,/9j/2wBDABALDA4MChAODQ4SERATGCgaGBYWGDEjJR0oOjM9PDkzODdASFxOQERXRTc4UG1RV19iZ2hnPk1xeXBkeFxlZ2P/2wBDARESEhgVGC8aGi9jQjhCY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2P/wgARCAAPABQDASIAAhEBAxEB/8QAGQAAAgMBAAAAAAAAAAAAAAAAAAQBAgMF/8QAFQEBAQAAAAAAAAAAAAAAAAAAAQL/2gAMAwEAAhADEAAAAeU2nszBQH//xAAaEAACAwEBAAAAAAAAAAAAAAAAAQIRExID/9oACAEBAAEFAoefRlGmiE+Telsz/8QAFBEBAAAAAAAAAAAAAAAAAAAAEP/aAAgBAwEBPwE//8QAFREBAQAAAAAAAAAAAAAAAAAAARD/2gAIAQIBAT8BWf/EABkQAAIDAQAAAAAAAAAAAAAAAAABEBExwf/aAAgBAQAGPwIfTXFUo//EAB0QAAIABwEAAAAAAAAAAAAAAAABESExQVFhwXH/2gAIAQEAAT8hiMCTSirtwm8ixn6JmVejGkf/2gAMAwEAAgADAAAAEIgv/8QAFhEAAwAAAAAAAAAAAAAAAAAAAAER/9oACAEDAQE/EEoQ/8QAFREBAQAAAAAAAAAAAAAAAAAAABH/2gAIAQIBAT8Qqr//xAAbEAEAAwADAQAAAAAAAAAAAAABABEhMUGBcf/aAAgBAQABPxBqhActW+EdAwY78EIrZ8zAt2N84VlKurKiGDDouf/Z')",
              "backgroundSize": "cover",
              "display": "block"
            }
          }}></span>{`
  `}<img parentName="span" {...{
            "className": "gatsby-resp-image-image",
            "alt": "IBM Research, Yorktown Heights, NY exterior",
            "title": "IBM Research, Yorktown Heights, NY exterior",
            "src": "/workplace-xg/static/d1c4262a4e32bb3f5f19ed5143836c45/2e753/ibm-research.jpg",
            "srcSet": ["/workplace-xg/static/d1c4262a4e32bb3f5f19ed5143836c45/69549/ibm-research.jpg 288w", "/workplace-xg/static/d1c4262a4e32bb3f5f19ed5143836c45/473e3/ibm-research.jpg 576w", "/workplace-xg/static/d1c4262a4e32bb3f5f19ed5143836c45/2e753/ibm-research.jpg 1152w", "/workplace-xg/static/d1c4262a4e32bb3f5f19ed5143836c45/a052a/ibm-research.jpg 1216w"],
            "sizes": "(max-width: 1152px) 100vw, 1152px",
            "style": {
              "width": "100%",
              "height": "100%",
              "margin": "0",
              "verticalAlign": "middle",
              "position": "absolute",
              "top": "0",
              "left": "0"
            },
            "loading": "lazy"
          }}></img>{`
    `}</span>
        <Caption mdxType="Caption">
  IBM Research, Yorktown Heights, New York
  <br />
  Designed by Eero Saarinen, 1961
        </Caption>
      </Column>
      <Column colLg={4} colMd={3} colSm={4} mdxType="Column">
        <span {...{
          "className": "gatsby-resp-image-wrapper",
          "style": {
            "position": "relative",
            "display": "block",
            "marginLeft": "auto",
            "marginRight": "auto",
            "maxWidth": "576px"
          }
        }}>{`
      `}<span parentName="span" {...{
            "className": "gatsby-resp-image-background-image",
            "style": {
              "paddingBottom": "100%",
              "position": "relative",
              "bottom": "0",
              "left": "0",
              "backgroundImage": "url('data:image/jpeg;base64,/9j/2wBDABALDA4MChAODQ4SERATGCgaGBYWGDEjJR0oOjM9PDkzODdASFxOQERXRTc4UG1RV19iZ2hnPk1xeXBkeFxlZ2P/2wBDARESEhgVGC8aGi9jQjhCY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2P/wgARCAAUABQDASIAAhEBAxEB/8QAFwABAQEBAAAAAAAAAAAAAAAAAAEDBP/EABUBAQEAAAAAAAAAAAAAAAAAAAEA/9oADAMBAAIQAxAAAAGzXCuRUMgeoJ//xAAbEAACAwEBAQAAAAAAAAAAAAABAgADEhETMv/aAAgBAQABBQLkK8noJW66sYGLVoOcIrlpT8//xAAUEQEAAAAAAAAAAAAAAAAAAAAg/9oACAEDAQE/AR//xAAUEQEAAAAAAAAAAAAAAAAAAAAg/9oACAECAQE/AR//xAAdEAABAwUBAAAAAAAAAAAAAAAAAREhAgMQQXGB/9oACAEBAAY/AicLwhR3LbbpJPT/xAAcEAEAAgIDAQAAAAAAAAAAAAABABEhMUFRgXH/2gAIAQEAAT8hkBcKcJMwTlNaPcPXZlkJdi+wCqeE2/U//9oADAMBAAIAAwAAABAgML//xAAUEQEAAAAAAAAAAAAAAAAAAAAg/9oACAEDAQE/EB//xAAWEQADAAAAAAAAAAAAAAAAAAAAARD/2gAIAQIBAT8QqP/EAB0QAQEAAgIDAQAAAAAAAAAAAAERADEhQVFxgcH/2gAIAQEAAT8QdAOcZryFnjFr6mISYYdxp+Zw5F07ztyRPuOZLrVWjfzFwGNsF94BsDNhc//Z')",
              "backgroundSize": "cover",
              "display": "block"
            }
          }}></span>{`
  `}<img parentName="span" {...{
            "className": "gatsby-resp-image-image",
            "alt": "IBM Research, Yorktown Heights, NY interior",
            "title": "IBM Research, Yorktown Heights, NY interior",
            "src": "/workplace-xg/static/5da3b9007dcbf8265ce7cf43382fcfb6/473e3/ibm-research-1.jpg",
            "srcSet": ["/workplace-xg/static/5da3b9007dcbf8265ce7cf43382fcfb6/69549/ibm-research-1.jpg 288w", "/workplace-xg/static/5da3b9007dcbf8265ce7cf43382fcfb6/473e3/ibm-research-1.jpg 576w"],
            "sizes": "(max-width: 576px) 100vw, 576px",
            "style": {
              "width": "100%",
              "height": "100%",
              "margin": "0",
              "verticalAlign": "middle",
              "position": "absolute",
              "top": "0",
              "left": "0"
            },
            "loading": "lazy"
          }}></img>{`
    `}</span>
        <Caption mdxType="Caption">
  IBM Research, Yorktown Heights, New York
  <br />
  Designed by Eero Saarinen, 1961
        </Caption>
      </Column>
      <Column colLg={4} colMd={3} colSm={4} mdxType="Column">
        <span {...{
          "className": "gatsby-resp-image-wrapper",
          "style": {
            "position": "relative",
            "display": "block",
            "marginLeft": "auto",
            "marginRight": "auto",
            "maxWidth": "576px"
          }
        }}>{`
      `}<span parentName="span" {...{
            "className": "gatsby-resp-image-background-image",
            "style": {
              "paddingBottom": "100%",
              "position": "relative",
              "bottom": "0",
              "left": "0",
              "backgroundImage": "url('data:image/jpeg;base64,/9j/2wBDABALDA4MChAODQ4SERATGCgaGBYWGDEjJR0oOjM9PDkzODdASFxOQERXRTc4UG1RV19iZ2hnPk1xeXBkeFxlZ2P/2wBDARESEhgVGC8aGi9jQjhCY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2P/wgARCAAUABQDASIAAhEBAxEB/8QAGAABAQEBAQAAAAAAAAAAAAAAAAQFAwb/xAAVAQEBAAAAAAAAAAAAAAAAAAABAv/aAAwDAQACEAMQAAAB0oO80vnmio35SWMUf//EABwQAAICAgMAAAAAAAAAAAAAAAACAQMEERIzNP/aAAgBAQABBQIzfOasLlmUZI5F/Wf/xAAUEQEAAAAAAAAAAAAAAAAAAAAg/9oACAEDAQE/AR//xAAUEQEAAAAAAAAAAAAAAAAAAAAg/9oACAECAQE/AR//xAAcEAACAAcAAAAAAAAAAAAAAAAAARARICIxQXH/2gAIAQEABj8CH2Gi/A5Kj//EABsQAQACAgMAAAAAAAAAAAAAAAEAERAhYaGx/9oACAEBAAE/IZ0GOSNoXY1cYwBj2IGif//aAAwDAQACAAMAAAAQGM88/8QAFREBAQAAAAAAAAAAAAAAAAAAEAH/2gAIAQMBAT8QKf/EABYRAQEBAAAAAAAAAAAAAAAAAAEQMf/aAAgBAgEBPxAhs//EAB0QAQACAgIDAAAAAAAAAAAAAAEAERAhMUFxwfD/2gAIAQEAAT8QGL6e8KdXhr1FoHBLXuOgLoCgKw9pEsm6n//Z')",
              "backgroundSize": "cover",
              "display": "block"
            }
          }}></span>{`
  `}<img parentName="span" {...{
            "className": "gatsby-resp-image-image",
            "alt": "Contrast in material",
            "title": "Contrast in material",
            "src": "/workplace-xg/static/a9a5e096e616d33de807fa992ccc8914/473e3/contrast-in-material.jpg",
            "srcSet": ["/workplace-xg/static/a9a5e096e616d33de807fa992ccc8914/69549/contrast-in-material.jpg 288w", "/workplace-xg/static/a9a5e096e616d33de807fa992ccc8914/473e3/contrast-in-material.jpg 576w"],
            "sizes": "(max-width: 576px) 100vw, 576px",
            "style": {
              "width": "100%",
              "height": "100%",
              "margin": "0",
              "verticalAlign": "middle",
              "position": "absolute",
              "top": "0",
              "left": "0"
            },
            "loading": "lazy"
          }}></img>{`
    `}</span>
        <Caption mdxType="Caption">Contrast in material</Caption>
      </Column>
      <Column colLg={8} colMd={5} colSm={4} mdxType="Column">
        <span {...{
          "className": "gatsby-resp-image-wrapper",
          "style": {
            "position": "relative",
            "display": "block",
            "marginLeft": "auto",
            "marginRight": "auto",
            "maxWidth": "1152px"
          }
        }}>{`
      `}<span parentName="span" {...{
            "className": "gatsby-resp-image-background-image",
            "style": {
              "paddingBottom": "75%",
              "position": "relative",
              "bottom": "0",
              "left": "0",
              "backgroundImage": "url('data:image/jpeg;base64,/9j/2wBDABALDA4MChAODQ4SERATGCgaGBYWGDEjJR0oOjM9PDkzODdASFxOQERXRTc4UG1RV19iZ2hnPk1xeXBkeFxlZ2P/2wBDARESEhgVGC8aGi9jQjhCY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2P/wgARCAAPABQDASIAAhEBAxEB/8QAFgABAQEAAAAAAAAAAAAAAAAABAAD/8QAFgEBAQEAAAAAAAAAAAAAAAAAAQAD/9oADAMBAAIQAxAAAAE2b9MwE6n/xAAZEAEBAQADAAAAAAAAAAAAAAACAAESEzL/2gAIAQEAAQUCGi9PsGWkFYbmb//EABYRAQEBAAAAAAAAAAAAAAAAAAASAf/aAAgBAwEBPwGdS//EABQRAQAAAAAAAAAAAAAAAAAAABD/2gAIAQIBAT8BP//EAB0QAAIBBAMAAAAAAAAAAAAAAAABEgIDEZETIjP/2gAIAQEABj8CcaXsSMRqOtvJLhWzyR//xAAaEAEAAwEBAQAAAAAAAAAAAAABABEhMVFx/9oACAEBAAE/IQB1DrAWnLCK3g+RFgMW6gFAfGbdXn//2gAMAwEAAgADAAAAEJ8//8QAFhEBAQEAAAAAAAAAAAAAAAAAARAx/9oACAEDAQE/EFtj/8QAFxEBAAMAAAAAAAAAAAAAAAAAABEhQf/aAAgBAgEBPxCdU//EABwQAQACAwADAAAAAAAAAAAAAAERIQAxUUFh8P/aAAgBAQABPxAbEAy7SNRkBkdTwKGbqJL4cj0paJTdP1ZPcMOx6xCTKbp0pzo5/9k=')",
              "backgroundSize": "cover",
              "display": "block"
            }
          }}></span>{`
  `}<img parentName="span" {...{
            "className": "gatsby-resp-image-image",
            "alt": "IBM Research™",
            "title": "IBM Research™",
            "src": "/workplace-xg/static/9aa834337b4bbf810eae32b9529d36e0/2e753/ibm-research-2.jpg",
            "srcSet": ["/workplace-xg/static/9aa834337b4bbf810eae32b9529d36e0/69549/ibm-research-2.jpg 288w", "/workplace-xg/static/9aa834337b4bbf810eae32b9529d36e0/473e3/ibm-research-2.jpg 576w", "/workplace-xg/static/9aa834337b4bbf810eae32b9529d36e0/2e753/ibm-research-2.jpg 1152w", "/workplace-xg/static/9aa834337b4bbf810eae32b9529d36e0/a052a/ibm-research-2.jpg 1216w"],
            "sizes": "(max-width: 1152px) 100vw, 1152px",
            "style": {
              "width": "100%",
              "height": "100%",
              "margin": "0",
              "verticalAlign": "middle",
              "position": "absolute",
              "top": "0",
              "left": "0"
            },
            "loading": "lazy"
          }}></img>{`
    `}</span>
        <Caption mdxType="Caption">Biophilic elements in architecture</Caption>
      </Column>
      <Column colLg={4} colMd={4} colSm={4} mdxType="Column">
        <span {...{
          "className": "gatsby-resp-image-wrapper",
          "style": {
            "position": "relative",
            "display": "block",
            "marginLeft": "auto",
            "marginRight": "auto",
            "maxWidth": "576px"
          }
        }}>{`
      `}<span parentName="span" {...{
            "className": "gatsby-resp-image-background-image",
            "style": {
              "paddingBottom": "100%",
              "position": "relative",
              "bottom": "0",
              "left": "0",
              "backgroundImage": "url('data:image/jpeg;base64,/9j/2wBDABALDA4MChAODQ4SERATGCgaGBYWGDEjJR0oOjM9PDkzODdASFxOQERXRTc4UG1RV19iZ2hnPk1xeXBkeFxlZ2P/2wBDARESEhgVGC8aGi9jQjhCY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2P/wgARCAAUABQDASIAAhEBAxEB/8QAFwABAQEBAAAAAAAAAAAAAAAAAAQBAv/EABYBAQEBAAAAAAAAAAAAAAAAAAABAv/aAAwDAQACEAMQAAABsjo5zdYK8IhC/wD/xAAeEAEBAAIABwAAAAAAAAAAAAACAQADBBAREhMhI//aAAgBAQABBQJbKauJ2ixeSI/WkZ1Jzvt5Je//xAAUEQEAAAAAAAAAAAAAAAAAAAAg/9oACAEDAQE/AR//xAAUEQEAAAAAAAAAAAAAAAAAAAAg/9oACAECAQE/AR//xAAcEAACAgIDAAAAAAAAAAAAAAAAAQIRITEQQZH/2gAIAQEABj8CrZmKaFO6voueh5K50vD/xAAcEAEAAgIDAQAAAAAAAAAAAAABADERIUFhcRD/2gAIAQEAAT8hB3dzL7rqcGKzUW5maWMMKkAB47iK8eQVtz78e//aAAwDAQACAAMAAAAQf+fA/8QAFxEAAwEAAAAAAAAAAAAAAAAAAAERMf/aAAgBAwEBPxCJogsIf//EABYRAQEBAAAAAAAAAAAAAAAAAAEAEf/aAAgBAgEBPxDUbZXbW//EAB4QAQEAAgICAwAAAAAAAAAAAAERACFRkTFBcbHR/9oACAEBAAE/EFqoFZ8HrZvHFD0bQ4r+ZCJWEXpltDPsRDnAMGiVN6uWIQyhDqZJ3KNaYlVPAH7xlLX4Z//Z')",
              "backgroundSize": "cover",
              "display": "block"
            }
          }}></span>{`
  `}<img parentName="span" {...{
            "className": "gatsby-resp-image-image",
            "alt": "Intersection of form",
            "title": "Intersection of form",
            "src": "/workplace-xg/static/b28fecfac36cb7adbd55f5ef98387efc/473e3/intersection-of-form.jpg",
            "srcSet": ["/workplace-xg/static/b28fecfac36cb7adbd55f5ef98387efc/69549/intersection-of-form.jpg 288w", "/workplace-xg/static/b28fecfac36cb7adbd55f5ef98387efc/473e3/intersection-of-form.jpg 576w"],
            "sizes": "(max-width: 576px) 100vw, 576px",
            "style": {
              "width": "100%",
              "height": "100%",
              "margin": "0",
              "verticalAlign": "middle",
              "position": "absolute",
              "top": "0",
              "left": "0"
            },
            "loading": "lazy"
          }}></img>{`
    `}</span>
        <Caption mdxType="Caption">Intersection of form</Caption>
      </Column>
      <Column colLg={4} colMd={4} colSm={4} mdxType="Column">
        <span {...{
          "className": "gatsby-resp-image-wrapper",
          "style": {
            "position": "relative",
            "display": "block",
            "marginLeft": "auto",
            "marginRight": "auto",
            "maxWidth": "576px"
          }
        }}>{`
      `}<span parentName="span" {...{
            "className": "gatsby-resp-image-background-image",
            "style": {
              "paddingBottom": "100%",
              "position": "relative",
              "bottom": "0",
              "left": "0",
              "backgroundImage": "url('data:image/jpeg;base64,/9j/2wBDABALDA4MChAODQ4SERATGCgaGBYWGDEjJR0oOjM9PDkzODdASFxOQERXRTc4UG1RV19iZ2hnPk1xeXBkeFxlZ2P/2wBDARESEhgVGC8aGi9jQjhCY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2P/wgARCAAUABQDASIAAhEBAxEB/8QAFwABAQEBAAAAAAAAAAAAAAAAAAQDBf/EABUBAQEAAAAAAAAAAAAAAAAAAAAB/9oADAMBAAIQAxAAAAHo4bTWUsBXEF4l/8QAHBAAAwACAwEAAAAAAAAAAAAAAAECERIDBDEz/9oACAEBAAEFAp8udzOqoduRZpcrLOv8v//EABQRAQAAAAAAAAAAAAAAAAAAACD/2gAIAQMBAT8BH//EABQRAQAAAAAAAAAAAAAAAAAAACD/2gAIAQIBAT8BH//EABsQAAICAwEAAAAAAAAAAAAAAAARATECICFR/9oACAEBAAY/ApyFUisXhwa0/8QAGxABAAIDAQEAAAAAAAAAAAAAAQAhETFBcWH/2gAIAQEAAT8hAI5R7AGC/CBDcFsetCGKGJWHicJYua/Wf//aAAwDAQACAAMAAAAQAy8A/8QAFxEAAwEAAAAAAAAAAAAAAAAAAAEREP/aAAgBAwEBPxCsjHn/xAAYEQADAQEAAAAAAAAAAAAAAAAAAREQQf/aAAgBAgEBPxCLpULP/8QAHBABAQACAwEBAAAAAAAAAAAAAREAITFBUXGh/9oACAEBAAE/EBRpo+rK4bQ77yepQLBe8nMRTZK9uNGgRXv5hKsuEcaCiOt45EQJxnB8D9z/2Q==')",
              "backgroundSize": "cover",
              "display": "block"
            }
          }}></span>{`
  `}<img parentName="span" {...{
            "className": "gatsby-resp-image-image",
            "alt": "Reflection of form",
            "title": "Reflection of form",
            "src": "/workplace-xg/static/33f80a84fd9d6d0a4ee22a63254e81ad/473e3/reflection-of-form.jpg",
            "srcSet": ["/workplace-xg/static/33f80a84fd9d6d0a4ee22a63254e81ad/69549/reflection-of-form.jpg 288w", "/workplace-xg/static/33f80a84fd9d6d0a4ee22a63254e81ad/473e3/reflection-of-form.jpg 576w"],
            "sizes": "(max-width: 576px) 100vw, 576px",
            "style": {
              "width": "100%",
              "height": "100%",
              "margin": "0",
              "verticalAlign": "middle",
              "position": "absolute",
              "top": "0",
              "left": "0"
            },
            "loading": "lazy"
          }}></img>{`
    `}</span>
        <Caption mdxType="Caption">Reflection of form</Caption>
      </Column>
      <Column colLg={4} colMd={4} colSm={4} mdxType="Column">
        <span {...{
          "className": "gatsby-resp-image-wrapper",
          "style": {
            "position": "relative",
            "display": "block",
            "marginLeft": "auto",
            "marginRight": "auto",
            "maxWidth": "576px"
          }
        }}>{`
      `}<span parentName="span" {...{
            "className": "gatsby-resp-image-background-image",
            "style": {
              "paddingBottom": "100%",
              "position": "relative",
              "bottom": "0",
              "left": "0",
              "backgroundImage": "url('data:image/jpeg;base64,/9j/2wBDABALDA4MChAODQ4SERATGCgaGBYWGDEjJR0oOjM9PDkzODdASFxOQERXRTc4UG1RV19iZ2hnPk1xeXBkeFxlZ2P/2wBDARESEhgVGC8aGi9jQjhCY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2P/wgARCAAUABQDASIAAhEBAxEB/8QAFwABAQEBAAAAAAAAAAAAAAAAAAMBBP/EABcBAQEBAQAAAAAAAAAAAAAAAAABAgP/2gAMAwEAAhADEAAAAZ1hXluYrl0sA//EABsQAAICAwEAAAAAAAAAAAAAAAABAhIDERMh/9oACAEBAAEFAoo35U6Mlnm11ZY2WZ//xAAWEQEBAQAAAAAAAAAAAAAAAAARABD/2gAIAQMBAT8BZ3//xAAWEQEBAQAAAAAAAAAAAAAAAAARABD/2gAIAQIBAT8BI3//xAAbEAABBAMAAAAAAAAAAAAAAAAAARAhMQJBof/aAAgBAQAGPwJ4UnLhZopG/8QAGxABAAIDAQEAAAAAAAAAAAAAAQARITFRELH/2gAIAQEAAT8ho2RDpFLqZ7S4AEzwTt9S/PG5tT//2gAMAwEAAgADAAAAELzffP/EABURAQEAAAAAAAAAAAAAAAAAABEg/9oACAEDAQE/EHD/xAAVEQEBAAAAAAAAAAAAAAAAAAABIP/aAAgBAgEBPxBMP//EAB8QAQACAgEFAQAAAAAAAAAAAAEAESEx0VFxgZGx4f/aAAgBAQABPxBMLRlUv5jJDK9mWl65hUQLwPm5QAK1v8RTFXYiQx6XmBYpdCf/2Q==')",
              "backgroundSize": "cover",
              "display": "block"
            }
          }}></span>{`
  `}<img parentName="span" {...{
            "className": "gatsby-resp-image-image",
            "alt": "Contrast in texture",
            "title": "Contrast in texture",
            "src": "/workplace-xg/static/1c14f5ab82437bad60cfad4baebd7c49/473e3/contrast-in-texture.jpg",
            "srcSet": ["/workplace-xg/static/1c14f5ab82437bad60cfad4baebd7c49/69549/contrast-in-texture.jpg 288w", "/workplace-xg/static/1c14f5ab82437bad60cfad4baebd7c49/473e3/contrast-in-texture.jpg 576w"],
            "sizes": "(max-width: 576px) 100vw, 576px",
            "style": {
              "width": "100%",
              "height": "100%",
              "margin": "0",
              "verticalAlign": "middle",
              "position": "absolute",
              "top": "0",
              "left": "0"
            },
            "loading": "lazy"
          }}></img>{`
    `}</span>
        <Caption mdxType="Caption">Contrast in texture</Caption>
      </Column>
      <Column colLg={4} colMd={3} colSm={4} mdxType="Column">
        <GifPlayer className="video-player" color="dark" mdxType="GifPlayer">
          <video src={ibmWatson} autoPlay="autoplay" loop playsInline muted style={{
            "width": "100%"
          }} />
          <span {...{
            "className": "gatsby-resp-image-wrapper",
            "style": {
              "position": "relative",
              "display": "block",
              "marginLeft": "auto",
              "marginRight": "auto",
              "maxWidth": "1000px"
            }
          }}>{`
      `}<span parentName="span" {...{
              "className": "gatsby-resp-image-background-image",
              "style": {
                "paddingBottom": "100%",
                "position": "relative",
                "bottom": "0",
                "left": "0",
                "backgroundImage": "url('data:image/jpeg;base64,/9j/2wBDABALDA4MChAODQ4SERATGCgaGBYWGDEjJR0oOjM9PDkzODdASFxOQERXRTc4UG1RV19iZ2hnPk1xeXBkeFxlZ2P/2wBDARESEhgVGC8aGi9jQjhCY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2P/wgARCAAUABQDASIAAhEBAxEB/8QAGAABAAMBAAAAAAAAAAAAAAAAAAIDBAX/xAAUAQEAAAAAAAAAAAAAAAAAAAAA/9oADAMBAAIQAxAAAAHvxUGkAAH/xAAbEAABBAMAAAAAAAAAAAAAAAABAAIQESAiMf/aAAgBAQABBQJWIPAzbD//xAAUEQEAAAAAAAAAAAAAAAAAAAAg/9oACAEDAQE/AR//xAAUEQEAAAAAAAAAAAAAAAAAAAAg/9oACAECAQE/AR//xAAaEAAABwAAAAAAAAAAAAAAAAAAARAgITFx/9oACAEBAAY/AloFGt//xAAbEAEBAAEFAAAAAAAAAAAAAAABEQAQIDFBsf/aAAgBAQABPyFYXBmadxScZBSfW3//2gAMAwEAAgADAAAAEHPPAP/EABQRAQAAAAAAAAAAAAAAAAAAACD/2gAIAQMBAT8QH//EABQRAQAAAAAAAAAAAAAAAAAAACD/2gAIAQIBAT8QH//EABoQAQEBAQEBAQAAAAAAAAAAAAERACFRMYH/2gAIAQEAAT8QJ1YF4XOy9FucWgdwfccX1WzufU9sfzOuuXf/2Q==')",
                "backgroundSize": "cover",
                "display": "block"
              }
            }}></span>{`
  `}<img parentName="span" {...{
              "className": "gatsby-resp-image-image",
              "alt": "Animation of IBM Watson® logo",
              "title": "Animation of IBM Watson® logo",
              "src": "/workplace-xg/static/e3b4e5b23c861ff4dad5324c116bbc13/4edc6/ibm-watson-logo.jpg",
              "srcSet": ["/workplace-xg/static/e3b4e5b23c861ff4dad5324c116bbc13/69549/ibm-watson-logo.jpg 288w", "/workplace-xg/static/e3b4e5b23c861ff4dad5324c116bbc13/473e3/ibm-watson-logo.jpg 576w", "/workplace-xg/static/e3b4e5b23c861ff4dad5324c116bbc13/4edc6/ibm-watson-logo.jpg 1000w"],
              "sizes": "(max-width: 1000px) 100vw, 1000px",
              "style": {
                "width": "100%",
                "height": "100%",
                "margin": "0",
                "verticalAlign": "middle",
                "position": "absolute",
                "top": "0",
                "left": "0"
              },
              "loading": "lazy"
            }}></img>{`
    `}</span>
        </GifPlayer>
        <Caption mdxType="Caption">IBM Watson® logo</Caption>
      </Column>
      <Column colLg={8} colMd={5} colSm={4} mdxType="Column">
        <span {...{
          "className": "gatsby-resp-image-wrapper",
          "style": {
            "position": "relative",
            "display": "block",
            "marginLeft": "auto",
            "marginRight": "auto",
            "maxWidth": "1152px"
          }
        }}>{`
      `}<span parentName="span" {...{
            "className": "gatsby-resp-image-background-image",
            "style": {
              "paddingBottom": "75%",
              "position": "relative",
              "bottom": "0",
              "left": "0",
              "backgroundImage": "url('data:image/jpeg;base64,/9j/2wBDABALDA4MChAODQ4SERATGCgaGBYWGDEjJR0oOjM9PDkzODdASFxOQERXRTc4UG1RV19iZ2hnPk1xeXBkeFxlZ2P/2wBDARESEhgVGC8aGi9jQjhCY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2P/wgARCAAPABQDASIAAhEBAxEB/8QAFwAAAwEAAAAAAAAAAAAAAAAAAAMEAv/EABUBAQEAAAAAAAAAAAAAAAAAAAIB/9oADAMBAAIQAxAAAAFmagycaI//xAAZEAACAwEAAAAAAAAAAAAAAAAAAQIREhP/2gAIAQEAAQUC0dJNJIy4lyvDP//EABYRAQEBAAAAAAAAAAAAAAAAAAABEf/aAAgBAwEBPwGsr//EABQRAQAAAAAAAAAAAAAAAAAAABD/2gAIAQIBAT8BP//EAB0QAAEDBQEAAAAAAAAAAAAAAAABIaECESIxMtH/2gAIAQEABj8CvsakzdRVg4k8P//EABsQAQADAAMBAAAAAAAAAAAAAAEAESFBUWGB/9oACAEBAAE/IbhQdVLY37uEOXqmzAA9CDAWHojy39T/2gAMAwEAAgADAAAAEMz/AP/EABcRAAMBAAAAAAAAAAAAAAAAAAABESH/2gAIAQMBAT8Qq4xh/8QAFxEBAQEBAAAAAAAAAAAAAAAAAQARQf/aAAgBAgEBPxADtpf/xAAdEAEAAgICAwAAAAAAAAAAAAABABEhQVFhMXGB/9oACAEBAAE/EB0boUGt13FhBchRMLjsgPUb2I+GW3yx9cwqAx0y/u1SFfZ//9k=')",
              "backgroundSize": "cover",
              "display": "block"
            }
          }}></span>{`
  `}<img parentName="span" {...{
            "className": "gatsby-resp-image-image",
            "alt": "IBM Watson IoT® Headquarters, Munich, Germany",
            "title": "IBM Watson IoT® Headquarters, Munich, Germany",
            "src": "/workplace-xg/static/5ba923fff65a782445abd702ed0b67d6/2e753/ibm-watson-iot-headquarters.jpg",
            "srcSet": ["/workplace-xg/static/5ba923fff65a782445abd702ed0b67d6/69549/ibm-watson-iot-headquarters.jpg 288w", "/workplace-xg/static/5ba923fff65a782445abd702ed0b67d6/473e3/ibm-watson-iot-headquarters.jpg 576w", "/workplace-xg/static/5ba923fff65a782445abd702ed0b67d6/2e753/ibm-watson-iot-headquarters.jpg 1152w", "/workplace-xg/static/5ba923fff65a782445abd702ed0b67d6/a052a/ibm-watson-iot-headquarters.jpg 1216w"],
            "sizes": "(max-width: 1152px) 100vw, 1152px",
            "style": {
              "width": "100%",
              "height": "100%",
              "margin": "0",
              "verticalAlign": "middle",
              "position": "absolute",
              "top": "0",
              "left": "0"
            },
            "loading": "lazy"
          }}></img>{`
    `}</span>
        <Caption mdxType="Caption">IBM Watson IoT® Headquarters, Munich, Germany</Caption>
      </Column>
    </ImageCollection>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      